import React, { useState, useEffect } from "react";
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import fetchGenericSASToken from "./services/GetGenericSasToken";
import GenericDownloadButton from "./Download/GenericDownloadButton";
import DownloadButton from "./Download/DownloadButton";
import DownloadExcelButton from "./Download/DownloadExcelButton";
// import DownloadVideo from "./Download/DownloadVideo";
import handleDownloadClick from "./Download/onClickDownloadVideo";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "./Download/TooltipStyles.css";
import axios from "axios";
import Loader from "./Loader";
import handleReArchive from "./services/GetFilesReArchived";
import ErrorDisplay from "./utilities/ErrorDisplay";
import archiveIcon from "../icons/archive.png";
import failedToLoad from "../icons/failedToLoad.jpeg";
import {
  CardBuilder,
  CardDownloadIcon,
  Metadata,
} from "./utilities/CardBuilder";
import {
  toggleSiteExpansion,
  togglePatchWithoutSiteExpansion,
  togglePatchExpansion,
  toggleWorkTypeExpansion,
} from "./utilities/ToggleExpansion";
import DownloadSidebar from "./Download/DownloadSidebar";
import GalleryControlsBar from "./GalleryControlsBar";
import { useGalleryControls } from "./hooks/useGalleryControls";

const Gallery = ({
  fullUrlWithToken,
  searchApiUrl,
  showOnWebApiUrl,
  accessToken,
  workid,
  woli,
  sa,
  workNo,
  woliNo,
  saNo,
  saCaseNumber,
  searchMetaDataKey,
  searchMetaDataValue,
  saOrderNumber,
  saAccount,
  saCart,
  siteId,
  siteName,
  patchId,
  patchName,
  recordType,
  updateFlag,
  ptwId,
  ptwNumber,
}) => {
  const [users, setUsers] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [wo, setWo] = useState([]);
  const [unavailable, setUnavailable] = useState(false);
  const [serviceAppointment, setServiceAppointment] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [photoIndex, setPhotoIndex] = useState();
  const [blobUrls, setBlobUrls] = useState([]);
  // const [checkedState, setCheckedState] = useState(false);
  const [downloaded, setIsDownloaded] = useState(false);
  const [dateTime, setDateTime] = useState([]);
  const [ocrData, setOcrData] = useState([]);
  const [lat, setLat] = useState([]);
  const [long, setLong] = useState([]);
  const [capturedDate, setCapturedDate] = useState([]);
  const [dbInsertedDateTime, setDbInsertedDateTime] = useState([]);
  const [isOpenImage, setIsOpenImage] = useState(false);
  const [uploadedBy, setUploadedBy] = useState([]);
  const [organization, setOrganization] = useState([]);
  const [fileDesc, setFiledesc] = useState([]);
  const [allSelected, setAllSelected] = useState(false);

  const [imageError, setImageError] = useState({});
  const [listThumbnails, setListThumbnails] = useState([]);
  const [archivedImages, setArchivedImages] = useState([]);
  const [downloadImages, setDownloadImages] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);

  const [scase, setScase] = useState([]);
  const [genUsers, setgenUsers] = useState([]);
  const [genericStorageSasToken, setgenericStorageSasToken] = useState("");

  const [showOnWebChecked, setShowOnWebChecked] = useState({});
  const [newlyUncheckedIds, setNewlyUncheckedIds] = useState([]);
  const [newlyCheckedIds, setNewlyCheckedIds] = useState([]);

  const [usersReinstatement, setUsersReinstatement] = useState([]);
  const [expansionState, setExpansionState] = useState({});

  const [isCaptionVisible, setIsCaptionVisible] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState({});
  const [isDownloadSidebarVisible, setIsDownloadSidebarVisible] =
    useState(false);
  const [isDownloadSidebarCollapsed, setIsDownloadSidebarCollapsed] =
    useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(1);

  // Calculate the indexes of items to display on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleCaptionToggle = () => {
    setIsCaptionVisible(!isCaptionVisible);
  };

  const handleImageError = (index) => {
    setImageError((prevErrors) => ({ ...prevErrors, [index]: true }));
  };

  const handleMovePrevRequest = () => {
    const newIndex = (photoIndex + blobUrls.length - 1) % blobUrls.length;
    setPhotoIndex(newIndex);
  };

  const handleMoveNextRequest = () => {
    const newIndex = (photoIndex + 1) % blobUrls.length;
    setPhotoIndex(newIndex);
  };

  const downloadButton = [
    <button
      className="btn-download"
      disabled={!isCheckAll && downloadImages.length === 0}
      onClick={() => {
        if (isCheckAll) {
          ImgUri.forEach(function (e) {
            var fileurl = e.split("$")[0];
            var downloadFileName = e.split("$")[1];
            var downloadFileNameExtension = e.split("$")[2];
            fetch(fileurl)
              .then((response) => response.blob())
              .then((blob) => {
                var a = document.createElement("a");
                var url = URL.createObjectURL(blob);
                a.href = url;
                if (downloadFileName.includes(".")) {
                  a.download = downloadFileName;
                } else {
                  a.download =
                    downloadFileName + "." + downloadFileNameExtension;
                }
                a.click();
                URL.revokeObjectURL(url);
              })
              .catch((error) =>
                console.error("Error downloading attachment:", error),
              );
          });
        } else {
          downloadImages.forEach(function (e) {
            var fileurl = e.image.split("$")[0];
            var downloadFileName = e.image.split("$")[1];
            var downloadFileNameExtension = e.image.split("$")[2];
            fetch(fileurl)
              .then((response) => response.blob())
              .then((blob) => {
                var a = document.createElement("a");
                var url = URL.createObjectURL(blob);
                a.href = url;
                if (downloadFileName.includes(".")) {
                  a.download = downloadFileName;
                } else {
                  a.download =
                    downloadFileName + "." + downloadFileNameExtension;
                }
                a.click();
                URL.revokeObjectURL(url);
              })
              .catch((error) =>
                console.error("Error downloading attachment:", error),
              );
          });
          setIsDownloaded(true);
        }
      }}
    >
      Download
    </button>,
  ];

  const customButtons = [
    <button
      key="captionToggle"
      className="toggleImageCaptionButton"
      onClick={handleCaptionToggle}
    >
      {isCaptionVisible ? "Hide metadata" : "Show metadata"}
    </button>,
  ];

  let idArray = [];
  let defaulCheckedImages = [];

  const workdIds = wo.map((woId) => {
    return woId.workOrderNumber;
  });

  const onClose = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };

  //#region Loader
  const loaderOverlay = document.createElement("div");
  loaderOverlay.id = "loader-overlay";
  const loader = document.createElement("div");
  loader.id = "loader";
  document.body.appendChild(loaderOverlay);
  document.body.appendChild(loader);
  const loaderdiv = document.getElementById("loader");
  const loaderOverlaydiv = document.getElementById("loader-overlay");
  //#endregion

  const getSelectedUsers = async () => {
    let searchUrl;

    searchUrl = searchApiUrl.concat(`Search?`);

    if (workid != null) searchUrl = searchUrl.concat(`WorkOrderID=${workid}&`);
    if (workNo != null) searchUrl = searchUrl.concat(`WorkOrderNo=${workNo}&`);
    if (woli != null)
      searchUrl = searchUrl.concat(`WorkOrderLineItemID=${woli}&`);
    if (woliNo != null)
      searchUrl = searchUrl.concat(`WorkOrderLineItemNo=${woliNo}&`);
    if (sa != null) searchUrl = searchUrl.concat(`ServiceAppointmnetID=${sa}&`);
    if (saNo != null)
      searchUrl = searchUrl.concat(`ServiceAppointmnetNo=${saNo}&`);
    if (saCaseNumber != null)
      searchUrl = searchUrl.concat(`SalesforceCaseNumber=${saCaseNumber}&`);
    //SQS
    if (searchMetaDataKey != null)
      searchUrl = searchUrl.concat(`SearchMetaDataKey=${searchMetaDataKey}&`);
    if (searchMetaDataValue != null)
      searchUrl = searchUrl.concat(
        `SearchMetaDataValue=${searchMetaDataValue}&`,
      );
    //PS
    if (saOrderNumber != null)
      searchUrl = searchUrl.concat(`SalesforceOrderNumber=${saOrderNumber}&`);
    if (saAccount != null)
      searchUrl = searchUrl.concat(`SalesforceAccount=${saAccount}&`);
    if (saCart != null)
      searchUrl = searchUrl.concat(`SalesforceCart=${saCart}&`);
    //Reinstatement
    if (siteId != null) searchUrl = searchUrl.concat(`SiteId=${siteId}&`);
    if (siteName != null) searchUrl = searchUrl.concat(`SiteName=${siteName}&`);
    if (patchId != null) searchUrl = searchUrl.concat(`PatchId=${patchId}&`);
    if (patchName != null)
      searchUrl = searchUrl.concat(`PatchName=${patchName}&`);
    //PTW
    if (ptwId != null) searchUrl = searchUrl.concat(`PTWID=${ptwId}&`);
    if (ptwNumber != null)
      searchUrl = searchUrl.concat(`PTWNumber=${ptwNumber}&`);

    // Remove the trailing '&'
    searchUrl = searchUrl.substring(0, searchUrl.length - 1);
    console.log("Search api url with parameters :- " + searchUrl);
    // loaderdiv.style.visibility = "visible";
    // loaderOverlaydiv.style.display = "flex";
    setIsLoading(true);
    try {
      const response = await fetch(searchUrl, {
        method: "get",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        loaderdiv.style.visibility = "hidden";
        loaderOverlaydiv.style.display = "none";
        var Users = await response.json();
        // Normalize SA field names and use normalized array everywhere
        const normalizedUsers = Users.map((item) => ({
          ...item,
          serviceAppointmentNumber:
            item.serviceAppointmentNumber ||
            item.serviceAppointmentNo ||
            item.serviceAppointmnetNo ||
            item.ServiceAppointmentNo ||
            item.ServiceAppointmnetNo ||
            "",
        }));
        Users = normalizedUsers; // replace original for downstream use
        setUsersList(normalizedUsers);
        // Use normalizedUsers for downstream grouping/filtering so
        // `serviceAppointmentNumber` is consistently available.
        const checkedState = {};
        normalizedUsers.forEach((user) => {
          checkedState[user.id] = user.showOnWeb;
        });
        defaulCheckedImages = Users.reduce((acc, user) => {
          if (user.showOnWeb === "true") {
            acc.push(user.id);
          }
          return acc;
        }, []);
        setShowOnWebChecked(checkedState);

        function groupBy(arr, prop) {
          return Object.values(
            arr.reduce((aggregate, item) => {
              const val = item[prop];
              if (!aggregate[val]) {
                aggregate[val] = {
                  [prop]: val,
                  data: [],
                };
              }
              aggregate[val].data.push(item);
              return aggregate;
            }, {}),
          );
        }

        const groupByReinstatement = (data) => {
          const groupedData = {};
          let fileNoCounter = 1; // Initialize a counter for FileNo

          data.forEach((item) => {
            const {
              siteName,
              patchName,
              workOrderLineItemWorkType,
              workOrderLineItemNumber,
              serviceAppointmentNumber,
            } = item;

            // Assign FileNo if it is blank
            if (!item.FileNo) {
              item.FileNo = fileNoCounter++;
            }

            if (recordType === "Site" || recordType === "Patch") {
              // Group by siteName
              if (!groupedData[siteName]) {
                groupedData[siteName] = {};
              }

              // Group by patchName inside siteName
              if (!groupedData[siteName][patchName]) {
                groupedData[siteName][patchName] = {};
              }

              // Group by workOrderLineItemWorkType inside patchName
              if (
                !groupedData[siteName][patchName][workOrderLineItemWorkType]
              ) {
                groupedData[siteName][patchName][workOrderLineItemWorkType] =
                  {};
              }

              // Group by workOrderLineItemNumber inside workOrderLineItemWorkType
              if (
                !groupedData[siteName][patchName][workOrderLineItemWorkType][
                  workOrderLineItemNumber
                ]
              ) {
                groupedData[siteName][patchName][workOrderLineItemWorkType][
                  workOrderLineItemNumber
                ] = {};
              }

              // Group by serviceAppointmentNumber inside workOrderLineItemNumber
              if (
                !groupedData[siteName][patchName][workOrderLineItemWorkType][
                  workOrderLineItemNumber
                ][serviceAppointmentNumber]
              ) {
                groupedData[siteName][patchName][workOrderLineItemWorkType][
                  workOrderLineItemNumber
                ][serviceAppointmentNumber] = [];
              }

              // Push the item
              groupedData[siteName][patchName][workOrderLineItemWorkType][
                workOrderLineItemNumber
              ][serviceAppointmentNumber].push(item);
            } else if (recordType === "Reinstatement_Site_WOLI") {
              // Group by siteName
              if (!groupedData[siteName]) {
                groupedData[siteName] = {};
              }

              // Group by workOrderLineItemWorkType inside siteName
              if (!groupedData[siteName][workOrderLineItemWorkType]) {
                groupedData[siteName][workOrderLineItemWorkType] = {};
              }

              // Group by workOrderLineItemNumber inside workOrderLineItemWorkType
              if (
                !groupedData[siteName][workOrderLineItemWorkType][
                  workOrderLineItemNumber
                ]
              ) {
                groupedData[siteName][workOrderLineItemWorkType][
                  workOrderLineItemNumber
                ] = {};
              }

              // Group by serviceAppointmentNumber inside workOrderLineItemNumber
              if (
                !groupedData[siteName][workOrderLineItemWorkType][
                  workOrderLineItemNumber
                ][serviceAppointmentNumber]
              ) {
                groupedData[siteName][workOrderLineItemWorkType][
                  workOrderLineItemNumber
                ][serviceAppointmentNumber] = [];
              }

              // Push the item
              groupedData[siteName][workOrderLineItemWorkType][
                workOrderLineItemNumber
              ][serviceAppointmentNumber].push(item);
            } else {
              // Group by workOrderLineItemNumber
              if (!groupedData[workOrderLineItemNumber]) {
                groupedData[workOrderLineItemNumber] = {};
              }

              // Group by serviceAppointmentNumber inside workOrderLineItemNumber
              if (
                !groupedData[workOrderLineItemNumber][serviceAppointmentNumber]
              ) {
                groupedData[workOrderLineItemNumber][serviceAppointmentNumber] =
                  [];
              }

              // Push the item
              groupedData[workOrderLineItemNumber][
                serviceAppointmentNumber
              ].push(item);
            }
          });

          return groupedData;
        };

        if (
          saCaseNumber != null ||
          ptwId != null ||
          saOrderNumber != null ||
          searchMetaDataKey != null ||
          searchMetaDataValue != null ||
          saAccount != null ||
          saCart != null
        ) {
          if (Users.length === 0) {
            setUnavailable(true);
          } else {
            let genericStorageSasToken =
              await fetchGenericSASToken(accessToken);
            setgenericStorageSasToken(genericStorageSasToken);
            setgenUsers(Users);
            var SC = Users;
            setScase(SC);
          }
        } else {
          if (Users.length === 0) {
            setUnavailable(true);
          } else {
            // Use normalizedUsers (which contains normalized
            // `serviceAppointmentNumber`) for grouping so SA labels
            // are preserved when the API returns alternate field names.
            if (
              recordType === "Site" ||
              recordType === "Patch" ||
              recordType === "Reinstatement_Site_WOLI"
            ) {
              const groupedReinstatement =
                groupByReinstatement(normalizedUsers);
              setUsersReinstatement(groupedReinstatement);
            } else {
              const grouped = groupBy(
                normalizedUsers,
                "workOrderLineItemNumber",
              ).map((item) => ({
                ...item,
                data: groupBy(item.data, "serviceAppointmentNumber"),
              }));
              setUsers(grouped);
            }
            var WO = normalizedUsers;
            setWo(WO);
          }
        }
      } else if (response.status === 400) {
        loaderdiv.style.visibility = "hidden";
        loaderOverlaydiv.style.display = "none";
        // setUnavailable(true);
        setErrorMessage(
          "You currently do not have access to this page.\n Please try again.",
        );
      } else if (response.status === 401) {
        loaderdiv.style.visibility = "hidden";
        loaderOverlaydiv.style.display = "none";
        setErrorMessage(
          "You currently do not have access to this page.\n Please try again.",
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleAdd = (image, isFileArchived,fileId) => {
    const selectedItem = usersList.find(
      (item) => item.id === fileId, // adjust key name if needed
    );

    if (selectedItem) {
      setSelectedItems((prev) => {
        // Prevent duplicates
        const alreadyExists = prev.some((item) => item.id === fileId);

        return alreadyExists ? prev : [...prev, selectedItem];
      });
    }
    const selectedImages = [...downloadImages];
    selectedImages.push({ image, isFileArchived });
    setDownloadImages(selectedImages);
    setArchivedImages(selectedImages);
  };

  const handleRemove = (image,fileId) => {
setSelectedItems((prev) =>
    prev.filter((item) => item.id !== fileId)
  );

    const selectedImages = downloadImages.filter((img) => img.image !== image);
    setDownloadImages(selectedImages);
    setArchivedImages(selectedImages);
  };

  const handleAddThumb = (thumb) => {
    setListThumbnails((prevThumbs) => [...prevThumbs, thumb]);
  };

  const handleRemoveThumb = (thumb) => {
    setListThumbnails((prevThumbs) => prevThumbs.filter((t) => t !== thumb));
  };

  const resetGallerySelection = () => {
    setIsCheck([]);
    setIsCheckAll(false);
    setDownloadImages([]);
    setArchivedImages([]);
    setDownloadProgress({});
  };

  const {
    isGalleryControlsOpen,
    setIsGalleryControlsOpen,
    closeGalleryControls,
    galleryControlsMode,
    sortOption,
    groupByServiceAppointment,
    selectedFileTypeGroups,
    capturedDateFrom,
    capturedDateTo,
    isSingleDateMode,
    handleSingleDateModeChange,
    includeNoCapturedDate,
    selectedEngineers,
    selectedServiceAppointments,
    engineerSearch,
    setEngineerSearch,
    saSearch,
    setSaSearch,
    saOptions,
    toggleServiceAppointmentSelection,
    displayUsers,
    filteredUsersReinstatement,
    filteredDirectUsers,
    engineerOptions,
    arrayWoli,
    ImgUri,
    toggleFileTypeGroup,
    handleSortChange,
    toggleGroupByServiceAppointment,
    openGalleryControls,
    handleCapturedDateFromChange,
    handleCapturedDateToChange,
    handleIncludeNoCapturedDateChange,
    toggleEngineerSelection,
    clearGalleryFilters,
  } = useGalleryControls({
    users,
    usersReinstatement,
    directUsers: scase,
    recordType,
    setCurrentPage,
    resetGallerySelection,
  });

  const hasVisibleGalleryResults =
    displayUsers.length > 0 ||
    filteredDirectUsers.length > 0 ||
    Object.keys(filteredUsersReinstatement).length > 0;

  const renderNoItemsState = () => (
    <div className="galleryEmptyStatePage">
      <h3>No items found</h3>
      <p>
        Your current sort or filter settings returned no gallery items. Clear
        the filters to show everything again.
      </p>
      <button type="button" className="galleryEmptyStateButton" onClick={clearGalleryFilters}>
        Clear filters
      </button>
    </div>
  );

  const isWoliSearch = Boolean(woli || woliNo);

  const renderGalleryControlsSidebar = () => (
    <GalleryControlsBar
      isGalleryControlsOpen={isGalleryControlsOpen}
      setIsGalleryControlsOpen={setIsGalleryControlsOpen}
      closeGalleryControls={closeGalleryControls}
      galleryControlsMode={galleryControlsMode}
      openGalleryControls={openGalleryControls}
      sortOption={sortOption}
      handleSortChange={handleSortChange}
      groupByServiceAppointment={groupByServiceAppointment}
      toggleGroupByServiceAppointment={toggleGroupByServiceAppointment}
      showGroupByServiceAppointment={isWoliSearch}
      selectedFileTypeGroups={selectedFileTypeGroups}
      toggleFileTypeGroup={toggleFileTypeGroup}
      capturedDateFrom={capturedDateFrom}
      handleCapturedDateFromChange={handleCapturedDateFromChange}
      capturedDateTo={capturedDateTo}
      handleCapturedDateToChange={handleCapturedDateToChange}
      isSingleDateMode={isSingleDateMode}
      handleSingleDateModeChange={handleSingleDateModeChange}
      includeNoCapturedDate={includeNoCapturedDate}
      handleIncludeNoCapturedDateChange={handleIncludeNoCapturedDateChange}
      selectedEngineers={selectedEngineers}
      toggleEngineerSelection={toggleEngineerSelection}
      engineerSearch={engineerSearch}
      setEngineerSearch={setEngineerSearch}
      engineerOptions={engineerOptions}
      selectedServiceAppointments={selectedServiceAppointments}
      toggleServiceAppointmentSelection={toggleServiceAppointmentSelection}
      saSearch={saSearch}
      setSaSearch={setSaSearch}
      saOptions={saOptions}
      clearGalleryFilters={clearGalleryFilters}
      showToolbar={false}
    />
  );

  const renderDownloadSidebar = () => (
    <DownloadSidebar
      downloadProgress={downloadProgress}
      setDownloadProgress={setDownloadProgress}
      downloadImages={downloadImages}
      isCollapsed={isDownloadSidebarCollapsed}
      setIsCollapsed={setIsDownloadSidebarCollapsed}
      setDownloadImages={setDownloadImages}
      setIsCheck={setIsCheck}
      setIsCheckAll={setIsCheckAll}
      setIsDownloadSidebarVisible={setIsDownloadSidebarVisible}
    />
  );

  const SelectAllCheckbox = ({ isChecked, onChange }) => {
    return (
      <label className="selectAllButton">
        <input
          type="checkbox"
          name="selectAll"
          id="selectAll"
          className="selectAllCheckbox"
          onChange={onChange}
          checked={isChecked}
        />

        <span className="selectAllText">
          {isChecked ? "Unselect All" : "Select All"}
        </span>
      </label>
    );
  };

  const handleSelectAll = () => {
    setIsCheckAll((prevIsCheckAll) => {
      const newIsCheckAll = !prevIsCheckAll;

      if (newIsCheckAll) {
        const allIds = arrayWoli.map((li) => li.id);

        if (allIds.length === 0) {
          setIsCheck([]);
          setDownloadImages([]);
          setArchivedImages([]);
          setDownloadProgress({});
          return false;
        }
        setSelectedItems(usersList);
        setIsCheck(allIds);
        const newDownloadImages = allIds.map((id) => {
          const user = arrayWoli.find((user) => user.id === id);

          return {
            image:
              user.finalImageURL +
              "$" +
              user.fileName +
              "$" +
              user.imageFileExtension +
              "$" +
              (user.imageFileSize || user.fileSize || ""),
            isFileArchived: user.isFileArchived,
          };
        });
        setDownloadImages(newDownloadImages);
        setDownloadProgress({});
        setArchivedImages(newDownloadImages);
      } else {
        setIsCheck([]);
        setSelectedItems([]);
        setDownloadImages([]);
        setDownloadProgress({});
        setArchivedImages([]);
      }
      return newIsCheckAll;
    });
  };

  const genImgUri = scase.map((user) => {
    return (
      user.fileFinalURL +
      "$" +
      user.fileName +
      "$" +
      user.fileExtension +
      "$" +
      (user.fileSize || "")
    );
  });

  const handleClick = (e) => {
    const { id, checked } = e.target;
    let updatedIsCheck;
    if (checked) {
      updatedIsCheck = [...isCheck, id];
    } else {
      updatedIsCheck = isCheck.filter((item) => item !== id);
    }
    setIsCheck(updatedIsCheck);
    setIsCheckAll(false);
    if (scase.length > 0) {
      const newDownloadImages = updatedIsCheck.map((checkedId) => {
        const user = scase.find((user) => user.id === checkedId);
        return {
          image:
            user.fileFinalURL +
            "$" +
            user.fileName +
            "$" +
            user.fileExtension +
            "$" +
            (user.fileSize || ""),
          isFileArchived: user.isFileArchived,
        };
      });
      setDownloadImages(newDownloadImages);
      setArchivedImages(newDownloadImages);
    }
  };

  const genHandleSelectAll = () => {
    setIsCheckAll((prevIsCheckAll) => {
      const newIsCheckAll = !prevIsCheckAll;

      if (newIsCheckAll) {
        const allIds = scase.map((li) => li.id);
        setIsCheck(allIds);
        const newDownloadImages = allIds.map((id) => {
          const user = scase.find((user) => user.id === id);
          return {
            image:
              user.fileFinalURL +
              genericStorageSasToken +
              "$" +
              user.fileName +
              "$" +
              user.fileExtension +
              "$" +
              (user.fileSize || ""),
            isFileArchived: user.isFileArchived,
          };
        });
        setDownloadImages(newDownloadImages);
        setArchivedImages(newDownloadImages);
      } else {
        setIsCheck([]);
        setDownloadImages([]);
        setArchivedImages([]);
      }
      return newIsCheckAll;
    });
  };

  const handleShowOnWebClick = async () => {
    const checkedCheckboxes = document.querySelectorAll(
      'input[type="checkbox"][name^="selectShowOnWebName"]:checked',
    );
    const checkedIds = [];
    const nameOfFilesToShowOnWebsite = [];
    for (let i = 0; i < checkedCheckboxes.length; i++) {
      const checkbox = checkedCheckboxes[i];
      if (checkbox.checked) {
        checkedIds.push(checkbox.id);
        nameOfFilesToShowOnWebsite.push(checkbox.dataset.fileName);
      }
    }
    if (checkedCheckboxes.length > 3) {
      createDialogBox(
        "Warning",
        "Only 3 images are eligible to show on webiste. Please select less than or equal to 3 images",
        [],
        closeDialogBox,
      );
    } else if (checkedCheckboxes.length > 0 && checkedCheckboxes.length <= 3) {
      let searchShowOnWebUrl = showOnWebApiUrl.concat(`SearchFlagHttpTrigger?`);
      if (workNo != null) {
        searchShowOnWebUrl = searchShowOnWebUrl.concat(
          `WorkOrderNo=${workNo}&`,
        );
      }
      searchShowOnWebUrl = searchShowOnWebUrl.concat(`ShowOnWeb=true`);
      //searchShowOnWebUrl = searchShowOnWebUrl.substring(0,searchShowOnWebUrl.length-1);
      console.log(searchShowOnWebUrl);
      loaderdiv.style.visibility = "visible";
      loaderOverlaydiv.style.display = "flex";
      await fetch(searchShowOnWebUrl, {
        method: "get",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then(async (data) => {
              const idsWithFlagTrue = data.map((record) => record.id);
              const filterData = data.filter(
                (record) => record.showOnWeb === "true",
              );
              const commonValues = idsWithFlagTrue.filter((val) =>
                checkedIds.includes(val),
              );
              const totalCombinedArrayLength =
                checkedIds.length +
                idsWithFlagTrue.length -
                commonValues.length;
              if (
                totalCombinedArrayLength > 3 &&
                !idsWithFlagTrue.every((id) => checkedIds.includes(id))
              ) {
                loaderdiv.style.visibility = "hidden";
                loaderOverlaydiv.style.display = "none";
                const dialogOverlay = document.createElement("div");
                dialogOverlay.classList.add("dialog-overlay");
                const dialogBox = document.createElement("div");
                dialogBox.id = "dialog-box";
                const dialogBoxTitle = document.createElement("div");
                dialogBoxTitle.id = "dialog-box-title";
                dialogBoxTitle.innerHTML = "Information";
                const dialogBoxMessage = document.createElement("div");
                dialogBoxMessage.id = "dialog-box-message";
                dialogBoxMessage.innerHTML = `Below image(s) are already marked to shown on website. Do you want to override them?`;
                const orderListFilename = document.createElement("ol");
                orderListFilename.style.padding = "0 0 0 20px";
                orderListFilename.style.overflow = "auto";
                filterData.forEach((record) => {
                  const listItem = document.createElement("li");
                  listItem.textContent =
                    record.fileName + " in " + record.serviceAppointmentNumber;
                  orderListFilename.appendChild(listItem);
                });
                dialogBoxMessage.appendChild(orderListFilename);
                const yesButton = document.createElement("button");
                yesButton.id = "dialog-box-yes-button";
                yesButton.innerText = "Yes";
                yesButton.addEventListener("click", async () => {
                  closeDialogBox();
                  await updateShowOnWebFlag(checkedIds, newlyUncheckedIds);
                });
                const noButton = document.createElement("button");
                noButton.id = "dialog-box-no-button";
                noButton.innerText = "No";
                noButton.addEventListener("click", closeDialogBox);
                dialogBox.appendChild(dialogBoxTitle);
                dialogBox.appendChild(dialogBoxMessage);
                dialogBox.appendChild(yesButton);
                dialogBox.appendChild(noButton);
                document.body.appendChild(dialogOverlay);
                document.body.appendChild(dialogBox);
              } else {
                loaderdiv.style.visibility = "hidden";
                loaderOverlaydiv.style.display = "none";
                const dialogOverlay = document.createElement("div");
                dialogOverlay.classList.add("dialog-overlay");
                const dialogBox = document.createElement("div");
                dialogBox.id = "dialog-box";
                const dialogBoxTitle = document.createElement("div");
                dialogBoxTitle.id = "dialog-box-title";
                dialogBoxTitle.innerHTML = "Information";
                const dialogBoxMessage = document.createElement("div");
                dialogBoxMessage.id = "dialog-box-message";
                dialogBoxMessage.innerHTML = `Below image(s) will be shown on website. Do you want to proceed ?`;
                const orderListFilename = document.createElement("ol");
                orderListFilename.style.padding = "0 0 0 20px";
                orderListFilename.style.overflow = "auto";
                nameOfFilesToShowOnWebsite.forEach((record) => {
                  const listItem = document.createElement("li");
                  listItem.textContent = record;
                  orderListFilename.appendChild(listItem);
                });
                dialogBoxMessage.appendChild(orderListFilename);
                const yesButton = document.createElement("button");
                yesButton.id = "dialog-box-yes-button";
                yesButton.innerText = "Yes";
                yesButton.addEventListener("click", async () => {
                  closeDialogBox();
                  await updateShowOnWebFlag(checkedIds, newlyUncheckedIds);
                });
                const noButton = document.createElement("button");
                noButton.id = "dialog-box-no-button";
                noButton.innerText = "No";
                noButton.addEventListener("click", closeDialogBox);
                dialogBox.appendChild(dialogBoxTitle);
                dialogBox.appendChild(dialogBoxMessage);
                dialogBox.appendChild(yesButton);
                dialogBox.appendChild(noButton);
                document.body.appendChild(dialogOverlay);
                document.body.appendChild(dialogBox);
              }
            });
          } else if (response.status === 401) {
            loaderdiv.style.visibility = "hidden";
            loaderOverlaydiv.style.display = "none";
            let errMsg = `Token expired`;
            createDialogBox("Error", errMsg, [], closeDialogBox);
          } else {
            response.json().then((data) => {
              let errMsg = `Error: ${data.message}`;
              createDialogBox("Error", errMsg, [], closeDialogBox);
            });
          }
        })
        .catch((error) => {
          loaderdiv.style.visibility = "hidden";
          loaderOverlaydiv.style.display = "none";
          console.error("Error fetching images:", error);
          createDialogBox("Error", "Error : " + error, [], closeDialogBox);
        });
    } else {
      if (newlyUncheckedIds.length > 0) {
        await updateShowOnWebFlag([], newlyUncheckedIds);
      } else {
        createDialogBox(
          "Warning",
          "No image selected to show on website",
          [],
          closeDialogBox,
        );
      }
    }
  };

  const handleShowOnWebForSFCaseNumberClick = async () => {
    const checkedCheckboxes = document.querySelectorAll(
      'input[type="checkbox"][name^="selectShowOnWebName"]:checked',
    );
    const checkedIds = [];
    const nameOfFilesToShowOnWebsite = [];
    for (let i = 0; i < checkedCheckboxes.length; i++) {
      const checkbox = checkedCheckboxes[i];
      if (checkbox.checked) {
        checkedIds.push(checkbox.id);
        nameOfFilesToShowOnWebsite.push(checkbox.dataset.fileName);
      }
    }
    if (checkedCheckboxes.length > 3) {
      createDialogBox(
        "Warning",
        "Only 3 images are eligible to show on webiste. Please select less than or equal to 3 images",
        [],
        closeDialogBox,
      );
    } else if (checkedCheckboxes.length > 0 && checkedCheckboxes.length <= 3) {
      let searchShowOnWebUrl = showOnWebApiUrl.concat(`SearchFlagHttpTrigger?`);
      if (saCaseNumber != null) {
        searchShowOnWebUrl = searchShowOnWebUrl.concat(
          `SalesforceCaseNumber=${saCaseNumber}&`,
        );
      }
      searchShowOnWebUrl = searchShowOnWebUrl.concat(`ShowOnWeb=true`);
      //searchShowOnWebUrl = searchShowOnWebUrl.substring(0,searchShowOnWebUrl.length-1);
      console.log(searchShowOnWebUrl);
      loaderdiv.style.visibility = "visible";
      loaderOverlaydiv.style.display = "flex";
      await fetch(searchShowOnWebUrl, {
        method: "get",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then(async (data) => {
              loaderdiv.style.visibility = "hidden";
              loaderOverlaydiv.style.display = "none";
              const dialogOverlay = document.createElement("div");
              dialogOverlay.classList.add("dialog-overlay");
              const dialogBox = document.createElement("div");
              dialogBox.id = "dialog-box";
              const dialogBoxTitle = document.createElement("div");
              dialogBoxTitle.id = "dialog-box-title";
              dialogBoxTitle.innerHTML = "Information";
              const dialogBoxMessage = document.createElement("div");
              dialogBoxMessage.id = "dialog-box-message";
              dialogBoxMessage.innerHTML = `Below image(s) will be shown on website. Do you want to proceed ?`;
              const orderListFilename = document.createElement("ol");
              orderListFilename.style.padding = "0 0 0 20px";
              orderListFilename.style.overflow = "auto";
              nameOfFilesToShowOnWebsite.forEach((record) => {
                const listItem = document.createElement("li");
                listItem.textContent = record;
                orderListFilename.appendChild(listItem);
              });
              dialogBoxMessage.appendChild(orderListFilename);
              const yesButton = document.createElement("button");
              yesButton.id = "dialog-box-yes-button";
              yesButton.innerText = "Yes";
              yesButton.addEventListener("click", async () => {
                closeDialogBox();
                await updateShowOnWebFlag(checkedIds, newlyUncheckedIds);
              });
              const noButton = document.createElement("button");
              noButton.id = "dialog-box-no-button";
              noButton.innerText = "No";
              noButton.addEventListener("click", closeDialogBox);
              dialogBox.appendChild(dialogBoxTitle);
              dialogBox.appendChild(dialogBoxMessage);
              dialogBox.appendChild(yesButton);
              dialogBox.appendChild(noButton);
              document.body.appendChild(dialogOverlay);
              document.body.appendChild(dialogBox);
            });
          } else if (response.status === 401) {
            loaderdiv.style.visibility = "hidden";
            loaderOverlaydiv.style.display = "none";
            let errMsg = `Token expired`;
            createDialogBox("Error", errMsg, [], closeDialogBox);
          } else {
            response.json().then((data) => {
              let errMsg = `Error: ${data.message}`;
              createDialogBox("Error", errMsg, [], closeDialogBox);
            });
          }
        })
        .catch((error) => {
          loaderdiv.style.visibility = "hidden";
          loaderOverlaydiv.style.display = "none";
          console.error("Error fetching images:", error);
          createDialogBox(
            "Error",
            "Error fetching images: " + error,
            [],
            closeDialogBox,
          );
        });
    } else {
      if (newlyUncheckedIds.length > 0) {
        await updateShowOnWebFlag([], newlyUncheckedIds);
      } else {
        createDialogBox(
          "Warning",
          "No image selected to show on website",
          [],
          closeDialogBox,
        );
      }
    }
  };

  function createDialogBox(title, message, elements, onClose) {
    const dialogOverlay = document.createElement("div");
    dialogOverlay.classList.add("dialog-overlay");
    const dialogBox = document.createElement("div");
    dialogBox.id = "dialog-box";
    const dialogBoxTitle = document.createElement("div");
    dialogBoxTitle.id = "dialog-box-title";
    dialogBoxTitle.innerHTML = title;
    const dialogBoxMessage = document.createElement("div");
    dialogBoxMessage.id = "dialog-box-message";
    dialogBoxMessage.innerHTML = message;
    // Add any additional elements to the message
    elements.forEach((element) => {
      const el = document.createElement(element.type);
      el.textContent = element.text;
      if (element.attributes) {
        Object.keys(element.attributes).forEach((attr) => {
          el.setAttribute(attr, element.attributes[attr]);
        });
      }
      if (element.listener) {
        el.addEventListener(element.listener.event, element.listener.callback);
      }
      dialogBoxMessage.appendChild(el);
    });
    const closeButton = document.createElement("button");
    closeButton.id = "dialog-box-close-button";
    closeButton.innerText = "Close";
    closeButton.addEventListener("click", onClose);
    dialogBox.appendChild(dialogBoxTitle);
    dialogBox.appendChild(dialogBoxMessage);
    dialogBox.appendChild(closeButton);
    document.body.appendChild(dialogOverlay);
    document.body.appendChild(dialogBox);
  }

  async function updateShowOnWebFlag(checkedIdsArray, unCheckedIdsArray) {
    
    const payload = {
      arrayOfCheckedRecords: checkedIdsArray,
      arrayOfUncheckedRecords: unCheckedIdsArray,
    };

    if (workid != null && workid !== "") {
      payload.workOrderNumber = workid;
    }
    
    if (workNo != null && workNo !== "") {
      payload.workOrderNumber = workNo;
    }

    if (saCaseNumber != null && saCaseNumber !== "") {
      payload.salesforceCaseNumber = saCaseNumber;
    }

    const updateFlagUrl = showOnWebApiUrl.concat(`UpdateFlagHttpTrigger`);

    loaderdiv.style.visibility = "visible";
    loaderOverlaydiv.style.display = "flex";
    
    console.log("Payload sent to UpdateFlagHttpTrigger:", payload);
    try {
    const response = await fetch(updateFlagUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    loaderdiv.style.visibility = "hidden";
    loaderOverlaydiv.style.display = "none";
    
    if (response.status === 204) {
      createDialogBox("Success", "Updated Successfully", [], closeAfterUpdatingDialogBox);
      return;
    }

    const errorText = await response.text();
    createDialogBox("Error", `Error: ${errorText}`, [], closeDialogBox);
  } catch (error) {
    loaderdiv.style.visibility = "hidden";
    loaderOverlaydiv.style.display = "none";
    console.error("Error while Updating flag:", error);
    createDialogBox("Error", "Error while Updating flag : " + error, [], closeAfterUpdatingDialogBox);
  }
  }

  const closeDialogBox = () => {
    const dialogBox = document.querySelector("#dialog-box");
    const dialogOverlay = document.querySelector(".dialog-overlay");
    dialogBox.parentNode.removeChild(dialogBox);
    dialogOverlay.parentNode.removeChild(dialogOverlay);
    document.body.classList.remove("dialog-open");
  };
  const closeAfterUpdatingDialogBox = () => {
    const dialogBox = document.querySelector("#dialog-box");
    const dialogOverlay = document.querySelector(".dialog-overlay");
    dialogBox.parentNode.removeChild(dialogBox);
    dialogOverlay.parentNode.removeChild(dialogOverlay);
    document.body.classList.remove("dialog-open");
    window.location.href = fullUrlWithToken;
  };

  const handleShowOnWebChange = (id, checked) => {
    setShowOnWebChecked((prevState) => ({
      ...prevState,
      [id]: checked,
    }));

    if (!checked) {
      setNewlyUncheckedIds((prevState) => [...prevState, id]);
    } else {
      setNewlyUncheckedIds((prevState) =>
        prevState.filter((item) => item !== id),
      );
    }
  };

  const handleShowOnWebChangeForChecked = (id, checked) => {
    setShowOnWebChecked((prevState) => ({
      ...prevState,
      [id]: checked,
    }));

    if (checked) {
      setNewlyCheckedIds((prevState) => [...prevState, id]);
    } else {
      setNewlyCheckedIds((prevState) =>
        prevState.filter((item) => item !== id),
      );
    }
  };

  const normalizeOwnerValue = (value) =>
    (value || "").toString().trim().toLowerCase();

  const recordMatchesSelectedEngineer = (record) => {
    if (selectedEngineers.length === 0) {
      return true;
    }

    return selectedEngineers.some(
      (engineerName) =>
        normalizeOwnerValue(engineerName) ===
        normalizeOwnerValue(record?.owner),
    );
  };

  function renderImageListItems(
    records,
    downloadProgress,
    handleDownloadClick,
  ) {
    const visibleRecords =
      selectedEngineers.length > 0
        ? records.filter(recordMatchesSelectedEngineer)
        : records;

    if (visibleRecords.length === 0) {
      return null;
    }

    return visibleRecords.map((user, index) => {
      const {
        // FileNo = index + 1,
        FileNo,
        id,
        workOrderID,
        workOrderNumber,
        workOrderLineItemID,
        workOrderLineItemNumber,
        serviceAppointmnetID,
        serviceAppointmentNumber,
        finalImageURL,
        thumbNailURL,
        longitude,
        latitude,
        owner,
        dateOnImage,
        dbInsertedDateTime,
        imageUploadedDateTime,
        imageFileSize,
        imageFileExtension,
        fileName,
        fileDescription,
        siteName,
        patchName,
        workOrderLineItemWorkType,
        isFileArchived,
      } = user;

      const validExtensions = ["png", "jpg", "jpeg", "heif", "heic"];
      if (validExtensions.includes((imageFileExtension || "").toLowerCase())) {
        return (
          <li key={id}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              isCheckAll={isCheckAll}
              handleSelectAll={handleSelectAll}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            <LazyLoadImage
              effect="blur"
              delayTime={100}
              threshold={500}
              src={
                imageError[id]
                  ? isFileArchived === "true"
                    ? archiveIcon // Case 1: error + archived
                    : failedToLoad // Case 2: error only
                  : thumbNailURL || finalImageURL // Case 3 & 4: no error
              }
              alt={workOrderID}
              onError={() => handleImageError(id)}
              onClick={() => {
                setOcrData(
                  visibleRecords.map((blob) => {
                    return blob.ocrData;
                  }),
                );
                setServiceAppointment(
                  visibleRecords.map((blob) => {
                    return blob.serviceAppointmentNumber;
                  }),
                );
                setCapturedDate(
                  visibleRecords.map((blob) => {
                    return blob.dateOnImage;
                  }),
                );
                setDbInsertedDateTime(
                  visibleRecords.map((blob) => {
                    return blob.dbInsertedDateTime;
                  }),
                );
                setDateTime(
                  visibleRecords.map((blob) => {
                    return blob.imageUploadedDateTime;
                  }),
                );
                setLat(
                  visibleRecords.map((blob) => {
                    return blob.latitude;
                  }),
                );
                setLong(
                  visibleRecords.map((blob) => {
                    return blob.longitude;
                  }),
                );
                setUploadedBy(
                  visibleRecords.map((blob) => {
                    return blob.owner;
                  }),
                );
                setOrganization(
                  visibleRecords.map((blob) => {
                    return blob.ownerOrganization;
                  }),
                );
                setPhotoIndex(visibleRecords.indexOf(user));
                setIsOpenImage(true);
                setBlobUrls(
                  visibleRecords.map((blob) => {
                    return blob.finalImageURL;
                  }),
                );
                setFiledesc(
                  visibleRecords.map((blob) => {
                    return blob.fileDescription;
                  }),
                );
              }}
            />

            <p style={{ float: "left" }} className="imgInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      }
      const videoExtensions = ["mp4", "avi", "hevc", "wmv", "mov"];
      if (videoExtensions.includes(imageFileExtension)) {
        return (
          <Tippy
            content={
              <>
                <strong>Note:</strong> The download time may vary based on your
                internet connection speed, specially for larger files. Please
                avoid refreshing the page while waiting.
              </>
            }
            placement="bottom"
            theme="custom"
          >
            <li className="docs" key={finalImageURL}>
              <CardBuilder
                id={id}
                finalImageURL={finalImageURL}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
                imageFileSize={imageFileSize}
                isFileArchived={isFileArchived}
                thumbNailURL={thumbNailURL}
                isCheck={isCheck}
                handleClick={handleClick}
                handleAdd={handleAdd}
                handleAddThumb={handleAddThumb}
                downloaded={downloaded}
                handleRemove={handleRemove}
                handleRemoveThumb={handleRemoveThumb}
              />
              {/* <a className="buttonVideo" href={finalImageURL} target="_blank"></a> */}

              {/* <a
                className="buttonVideo"
                href={finalImageURL}
                onClick={(e) =>
                  handleDownloadClick(
                    e,
                    fileName,
                    imageFileExtension,
                    finalImageURL
                  )
                }
              > */}
              <a
                className={`buttonVideo ${
                  isFileArchived === "true" ? "archivedDoc" : ""
                }`}
                href={finalImageURL}
                onClick={(e) =>
                  handleDownloadClick(
                    e,
                    fileName,
                    imageFileExtension,
                    finalImageURL,
                    setDownloadProgress,
                  )
                }
              >
                <CardDownloadIcon
                  finalImageURL={finalImageURL}
                  isFileArchived={isFileArchived}
                  downloadProgress={downloadProgress}
                />
              </a>

              <p className="docInfo">
                <Metadata
                  FileNo={FileNo}
                  workOrderNumber={workOrderNumber}
                  siteName={siteName}
                  patchName={patchName}
                  workOrderLineItemWorkType={workOrderLineItemWorkType}
                  workOrderLineItemNumber={workOrderLineItemNumber}
                  serviceAppointmentNumber={serviceAppointmentNumber}
                  dateOnImage={dateOnImage}
                  imageUploadedDateTime={imageUploadedDateTime}
                  dbInsertedDateTime={dbInsertedDateTime}
                  longitude={longitude}
                  latitude={latitude}
                  owner={owner}
                  fileDescription={fileDescription}
                  fileName={fileName}
                  imageFileExtension={imageFileExtension}
                />
              </p>
            </li>
          </Tippy>
        );
      } else if (
        imageFileExtension === "doc" ||
        imageFileExtension === "docx"
      ) {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="buttonDoc" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`buttonDoc ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>

            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      } else if (
        imageFileExtension === "xls" ||
        imageFileExtension === "xlsx" ||
        imageFileExtension === "csv"
      ) {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="buttonXls" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`buttonXls ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>
            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      } else if (
        imageFileExtension === "ppt" ||
        imageFileExtension === "pptx"
      ) {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="buttonPpt" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`buttonPpt ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>

            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      } else if (imageFileExtension === "pdf") {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="buttonPdf" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`buttonPdf ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>

            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      } else {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="button" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`button ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>
            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      }
    });
  }
  function renderImageListItemsForShowOnWeb(
    records,
    downloadProgress,
    handleDownloadClick,
  ) {
    const visibleRecords =
      selectedEngineers.length > 0
        ? records.filter(recordMatchesSelectedEngineer)
        : records;

    if (visibleRecords.length === 0) {
      return null;
    }

    return visibleRecords.map((user, index) => {
      const {
        FileNo,
        // FileNo = index + 1,
        id,
        workOrderID,
        workOrderNumber,
        workOrderLineItemID,
        workOrderLineItemNumber,
        serviceAppointmnetID,
        serviceAppointmentNumber,
        finalImageURL,
        thumbNailURL,
        longitude,
        latitude,
        owner,
        dateOnImage,
        imageUploadedDateTime,
        dbInsertedDateTime,
        imageFileSize,
        imageFileExtension,
        fileName,
        fileDescription,
        isFileArchived,
        showOnWeb,
        siteName,
        patchName,
        workOrderLineItemWorkType,
      } = user;
      const validExtensions = ["png", "jpg", "jpeg", "heif", "heic"];
      if (validExtensions.includes((imageFileExtension || "").toLowerCase())) {
        return (
          <li key={id}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            <LazyLoadImage
              effect="blur"
              delayTime={100}
              threshold={500}
              src={
                imageError[id]
                  ? isFileArchived === "true"
                    ? archiveIcon // Case 1: error + archived
                    : failedToLoad // Case 2: error only
                  : thumbNailURL || finalImageURL // Case 3 & 4: no error
              }
              alt={workOrderID}
              onError={() => handleImageError(id)}
              onClick={() => {
                setOcrData(
                  visibleRecords.map((blob) => {
                    return blob.ocrData;
                  }),
                );
                setServiceAppointment(
                  visibleRecords.map((blob) => {
                    return blob.serviceAppointmentNumber;
                  }),
                );
                setCapturedDate(
                  visibleRecords.map((blob) => {
                    return blob.dateOnImage;
                  }),
                );
                setDbInsertedDateTime(
                  visibleRecords.map((blob) => {
                    return blob.dbInsertedDateTime;
                  }),
                );
                setDateTime(
                  visibleRecords.map((blob) => {
                    return blob.imageUploadedDateTime;
                  }),
                );
                setLat(
                  visibleRecords.map((blob) => {
                    return blob.latitude;
                  }),
                );
                setLong(
                  visibleRecords.map((blob) => {
                    return blob.longitude;
                  }),
                );
                setUploadedBy(
                  visibleRecords.map((blob) => {
                    return blob.owner;
                  }),
                );
                setOrganization(
                  visibleRecords.map((blob) => {
                    return blob.ownerOrganization;
                  }),
                );
                setPhotoIndex(visibleRecords.indexOf(user));
                setIsOpenImage(true);
                setBlobUrls(
                  visibleRecords.map((blob) => {
                    return blob.finalImageURL;
                  }),
                );
                setFiledesc(
                  visibleRecords.map((blob) => {
                    return blob.fileDescription;
                  }),
                );
              }}
            />
            <p style={{ float: "left" }} className="imgInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />

              {/* Release 4.1 */}
              <br />
              <br />
              {showOnWeb === "true" && isFileArchived !== "true" ? (
                <label className="showOnwebLabel">
                  <input
                    type="checkbox"
                    name={"selectShowOnWebName"}
                    id={id}
                    data-file-name={fileName + "." + imageFileExtension}
                    className="firstShowOnWebbox"
                    checked={showOnWebChecked[id]}
                    onChange={(event) =>
                      handleShowOnWebChange(id, event.target.checked)
                    }
                  />
                  &nbsp;&nbsp;Show on website
                </label>
              ) : (showOnWeb === "false" || showOnWeb === "") &&
                isFileArchived !== "true" ? (
                <label className="showOnwebLabel">
                  <input
                    type="checkbox"
                    name={"selectShowOnWebName"}
                    id={id}
                    data-file-name={fileName + "." + imageFileExtension}
                    className="firstShowOnWebbox"
                    onChange={(event) =>
                      handleShowOnWebChangeForChecked(id, event.target.checked)
                    }
                  />
                  &nbsp;&nbsp;Show on website
                </label>
              ) : null}
              {/* Release 4.1 */}
            </p>
          </li>
        );
      }
      if (
        imageFileExtension === "mp4" ||
        imageFileExtension === "avi" ||
        imageFileExtension === "hevc" ||
        imageFileExtension === "wmv" ||
        imageFileExtension === "mov"
      ) {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="buttonVideo" href={finalImageURL} target="_blank"></a> */}
            {/* <a
              className="buttonVideo"
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL
                )
              }
            > */}
            <a
              className={`buttonVideo ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>
            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      } else if (
        imageFileExtension === "doc" ||
        imageFileExtension === "docx"
      ) {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="buttonDoc" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`buttonDoc ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>

            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      } else if (
        imageFileExtension === "xls" ||
        imageFileExtension === "xlsx" ||
        imageFileExtension === "csv"
      ) {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="buttonXls" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`buttonXls ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>

            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      } else if (
        imageFileExtension === "ppt" ||
        imageFileExtension === "pptx"
      ) {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="buttonPpt" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`buttonPpt ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>

            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      } else if (imageFileExtension === "pdf") {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="buttonPdf" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`buttonPdf ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>

            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      } else {
        return (
          <li className="docs" key={finalImageURL}>
            <CardBuilder
              id={id}
              finalImageURL={finalImageURL}
              fileName={fileName}
              imageFileExtension={imageFileExtension}
              imageFileSize={imageFileSize}
              isFileArchived={isFileArchived}
              thumbNailURL={thumbNailURL}
              isCheck={isCheck}
              handleClick={handleClick}
              handleAdd={handleAdd}
              handleAddThumb={handleAddThumb}
              downloaded={downloaded}
              handleRemove={handleRemove}
              handleRemoveThumb={handleRemoveThumb}
            />
            {/* <a className="button" href={finalImageURL} target="_blank"></a> */}
            <a
              className={`button ${
                isFileArchived === "true" ? "archivedDoc" : ""
              }`}
              href={finalImageURL}
              onClick={(e) =>
                handleDownloadClick(
                  e,
                  fileName,
                  imageFileExtension,
                  finalImageURL,
                  setDownloadProgress,
                )
              }
            >
              <CardDownloadIcon
                finalImageURL={finalImageURL}
                isFileArchived={isFileArchived}
                downloadProgress={downloadProgress}
              />
            </a>
            <p className="docInfo">
              <Metadata
                FileNo={FileNo}
                workOrderNumber={workOrderNumber}
                siteName={siteName}
                patchName={patchName}
                workOrderLineItemWorkType={workOrderLineItemWorkType}
                workOrderLineItemNumber={workOrderLineItemNumber}
                serviceAppointmentNumber={serviceAppointmentNumber}
                dateOnImage={dateOnImage}
                imageUploadedDateTime={imageUploadedDateTime}
                dbInsertedDateTime={dbInsertedDateTime}
                longitude={longitude}
                latitude={latitude}
                owner={owner}
                fileDescription={fileDescription}
                fileName={fileName}
                imageFileExtension={imageFileExtension}
              />
            </p>
          </li>
        );
      }
    });
  }
  function openLightbox() {
    return (
      <Lightbox
        animationOnKeyInput={true}
        clickOutsideToClose={false}
        imageTitle={`SA No. :\u00A0\u00A0${serviceAppointment[photoIndex]}`}
        toolbarButtons={customButtons}
        imageCaption={
          isCaptionVisible
            ? `GPS Loc :\u00A0\u00A0${
                (lat[photoIndex] == null ? "NA" : lat[photoIndex]) +
                "\xa0\xa0\xa0\xa0\xa0" +
                (long[photoIndex] == null ? "" : long[photoIndex])
              }\u00A0;\u00A0
        WO Loc :\u00A0\u00A0${
          (lat[photoIndex] == null ? "NA" : lat[photoIndex]) +
          "\xa0\xa0\xa0\xa0\xa0" +
          (long[photoIndex] == null ? "" : long[photoIndex])
        }\u00A0;\u00A0
        CapturedDate :\u00A0\u00A0${
          capturedDate[photoIndex] == null ? "NA" : capturedDate[photoIndex]
        }\u00A0;\u00A0
        UploadedDate :\u00A0\u00A0${
          dateTime[photoIndex] == null ? "NA" : dateTime[photoIndex]
        }\u00A0;\u00A0
        Uploaded By :\u00A0\u00A0${
          uploadedBy[photoIndex] == null ? "NA" : uploadedBy[photoIndex]
        }\u00A0;\u00A0
        Organization :\u00A0\u00A0${
          organization[photoIndex] == null ? "NA" : organization[photoIndex]
        }\u00A0;\u00A0
        OCR Data :\u00A0\u00A0${ocrData[photoIndex]}\u00A0\u00A0
        File Description :\u00A0\u00A0${
          fileDesc[photoIndex] == null ? "NA" : fileDesc[photoIndex]
        }\u00A0;\u00A0`
            : ``
        }
        mainSrc={blobUrls[photoIndex]}
        mainSrcThumbnail={blobUrls[photoIndex]}
        imagePadding={100}
        nextSrc={blobUrls[(photoIndex + 1) % blobUrls.length]}
        prevSrc={blobUrls[(photoIndex + blobUrls.length - 1) % blobUrls.length]}
        onCloseRequest={() => {
          setIsCaptionVisible(false);
          setIsOpenImage(false);
          return;
        }}
        onMovePrevRequest={handleMovePrevRequest}
        onMoveNextRequest={handleMoveNextRequest}
      />
    );
  }

  const isSubmitButtonDisabled =
    newlyCheckedIds.length > 0 || newlyUncheckedIds.length > 0;

  useEffect(() => {
    getSelectedUsers();
  }, []);

  const PaginationUsers = ({
    extractedData,
    currentPage,
    setCurrentPage,
    isCheckAll,
  }) => {
    const maxButtons = 5; // Maximum number of buttons to display at once
    const halfMaxButtons = Math.floor(maxButtons / 2);

    // Calculate the range of pages to display
    const startPage = Math.max(1, currentPage - halfMaxButtons);
    const endPage = Math.min(extractedData.length, startPage + maxButtons - 1);

    const handleClick = (pageNumber) => () => {
      setCurrentPage(pageNumber);
      // setIsCheck([]);
      // isCheckAll(false);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // Update the last serviceAppointmentNumber
      if (currentItemsUsers.length > 0) {
        const lastItem = currentItemsUsers[currentItemsUsers.length - 1];
        // const lastSA = lastItem.data[lastItem.data.length - 1];
      }
    };
    return (
      <div className="pagination">
        <ul className="page">
          <li>
            <button
              className="color-button"
              onClick={handleClick(currentPage - 1)}
              disabled={currentPage === 1} // Disable if on the first page
            >
              Previous
            </button>
          </li>
          {Array.from(
            { length: endPage - startPage + 1 },
            (_, index) => startPage + index,
          ).map((pageNumber) => (
            <li
              key={pageNumber}
              className={currentPage === pageNumber ? "active" : ""}
            >
              <button
                className="color-button"
                onClick={handleClick(pageNumber)}
              >
                {pageNumber}
              </button>
            </li>
          ))}
          <li>
            <button
              className="color-button"
              onClick={handleClick(currentPage + 1)}
              disabled={currentPage === extractedData.length} // Disable if on the last page
            >
              Next
            </button>
          </li>
        </ul>
      </div>
    );
  };

  // const pageSize = 250;
  // let totalCount = 0;
  // let extractedData = [];
  // let tempGroup = [];
  // let currentWorkOrderLineItemNumber = "";
  // let fileNo = 1;
  // let lastServiceAppointmentNumber = ""; // Keep track of the last service appointment number

  // users.forEach((user) => {
  //   currentWorkOrderLineItemNumber = user.workOrderLineItemNumber;
  //   user.data.forEach((subItem) => {
  //     let subItemCount = subItem.data.length;
  //     let startIndex = 0; // Track the start index for slicing

  //     while (subItemCount > 0) {
  //       if (totalCount + Math.min(subItemCount, pageSize) > pageSize) {
  //         extractedData.push({
  //           workOrderLineItemNumber: currentWorkOrderLineItemNumber,
  //           data: tempGroup,
  //           ArrayLength: totalCount,
  //         });
  //         tempGroup = [];
  //         totalCount = 0;
  //       }

  //       let amountToAdd = Math.min(subItemCount, pageSize - totalCount);
  //       let dataToAdd = subItem.data
  //         .slice(startIndex, startIndex + amountToAdd)
  //         .map((item) => {
  //           // Check if the serviceAppointmentNumber is different from the last one
  //           if (
  //             item.serviceAppointmentNumber !== lastServiceAppointmentNumber
  //           ) {
  //             fileNo = 1; // Reset fileNo to 1 only if serviceAppointmentNumber different
  //             lastServiceAppointmentNumber = item.serviceAppointmentNumber; // Update the last service appointment number
  //           }
  //           let newItem = {
  //             ...item,
  //             FileNo: fileNo, // Assign the current fileNo
  //           };
  //           fileNo++; // Increment fileNo for the next item
  //           return newItem;
  //         });

  //       tempGroup.push({ ...subItem, data: dataToAdd });
  //       totalCount += amountToAdd;
  //       subItemCount -= amountToAdd;
  //       startIndex += amountToAdd; // Update startIndex
  //     }
  //   });

  //   if (tempGroup.length > 0) {
  //     extractedData.push({
  //       workOrderLineItemNumber: currentWorkOrderLineItemNumber,
  //       data: tempGroup,
  //       ArrayLength: totalCount,
  //     });
  //     tempGroup = [];
  //     totalCount = 0;
  //     fileNo = 1; // Reset fileNo after pushing to extractedData
  //   }
  // });

  const pageSize = process.env.REACT_APP_PAGE_SIZE ? parseInt(process.env.REACT_APP_PAGE_SIZE) : 250;
  let totalCount = 0;
  let extractedData = [];
  let tempGroup = [];

  const flushPage = () => {
    if (tempGroup.length === 0) return;
    extractedData.push({
      data: tempGroup,
      ArrayLength: totalCount,
    });
    tempGroup = [];
    totalCount = 0;
  };

  const getOrCreateWoli = (workOrderLineItemNumber) => {
    let woliGroup = tempGroup.find(
      (item) => item.workOrderLineItemNumber === workOrderLineItemNumber,
    );
    if (!woliGroup) {
      woliGroup = {
        workOrderLineItemNumber,
        data: [],
      };
      tempGroup.push(woliGroup);
    }
    return woliGroup;
  };

  displayUsers.forEach((user) => {
    const currentWorkOrderLineItemNumber = user.workOrderLineItemNumber;

    user.data.forEach((subItem) => {
      const visibleRecords =
        selectedEngineers.length > 0
          ? subItem.data.filter(recordMatchesSelectedEngineer)
          : subItem.data;

      if (visibleRecords.length === 0) {
        return;
      }

      const filesWithNumbers = visibleRecords.map((item, index) => ({
        ...item,
        FileNo: index + 1,
      }));

      let startIndex = 0;
      while (startIndex < filesWithNumbers.length) {
        const availableFileSlots = pageSize - totalCount;
        if (availableFileSlots <= 0) {
          flushPage();
          continue;
        }

        const amountToAdd = Math.min(
          availableFileSlots,
          filesWithNumbers.length - startIndex,
        );
        const chunk = filesWithNumbers.slice(
          startIndex,
          startIndex + amountToAdd,
        );

        const targetWoli = getOrCreateWoli(currentWorkOrderLineItemNumber);
        let targetSa = targetWoli.data.find(
          (sa) => sa.serviceAppointmentNumber === subItem.serviceAppointmentNumber,
        );

        if (!targetSa) {
          targetSa = {
            ...subItem,
            data: [],
          };
          targetWoli.data.push(targetSa);
        }

        targetSa.data = [...targetSa.data, ...chunk];
        totalCount += amountToAdd;
        startIndex += amountToAdd;

        if (totalCount >= pageSize) {
          flushPage();
        }
      }
    });
  });

  flushPage();
  //Removing Woli with No data to prevent blank page.
  extractedData = extractedData.filter((item) => item.data.length > 0);
  const normalizeSaNumber = (value) =>
    (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/^sa\W*/g, "");

  const pruneEmptyWorkOrders = (pages) =>
    pages
      .map((page) => {
        const visibleWoli = (page.data || [])
          .map((woli) => {
              const visibleSaGroups = (woli.data || [])
              .map((sa) => {
                const saNumber = (sa.serviceAppointmentNumber || "")
                  .toString()
                  .trim();

                if (
                  Array.isArray(selectedServiceAppointments) &&
                  selectedServiceAppointments.length > 0
                ) {
                  const normalizedSelectedSa = selectedServiceAppointments.map((s) =>
                    normalizeSaNumber(s),
                  );

                  // If this SA group itself has a number, compare directly.
                  if (saNumber) {
                    if (!normalizedSelectedSa.includes(normalizeSaNumber(saNumber))) {
                      return null;
                    }
                  } else {
                    // When grouping is disabled, SA groups might have an empty
                    // serviceAppointmentNumber. In that case, check if any record
                    // inside this group matches the selected SA values.
                    const anyRecordMatches = (sa.data || []).some((rec) =>
                      normalizedSelectedSa.includes(
                        normalizeSaNumber(
                          rec.serviceAppointmentNumber || rec.serviceAppointmnetNo || rec.serviceAppointmentNo || "",
                        ),
                      ),
                    );

                    if (!anyRecordMatches) {
                      return null;
                    }
                  }
                }

                // const visibleSaRecords =
                //   selectedEngineers.length > 0
                //     ? sa.data.filter(recordMatchesSelectedEngineer)
                //     : sa.data;

                const normalizedSelectedSa = selectedServiceAppointments.map((s) =>
  normalizeSaNumber(s),
);
const getServiceAppointmentNumber = (record) =>
  (
    record?.serviceAppointmentNumber ||
    record?.serviceAppointmnetID ||
    record?.serviceAppointmnetNo ||
    record?.serviceAppointmentNo ||
    ""
  )
    .toString()
    .trim();
const visibleSaRecords = (sa.data || []).filter((record) => {
  const engineerMatch =
    selectedEngineers.length === 0 ||
    recordMatchesSelectedEngineer(record);

  const saMatch =
    selectedServiceAppointments.length === 0 ||
    normalizedSelectedSa.includes(
      normalizeSaNumber(
        getServiceAppointmentNumber(record),
      ),
    );

  return engineerMatch && saMatch;
});
                // If grouping by Service Appointment is enabled, we only
                // show SA groups that have a non-empty SA number and
                // visible records. If grouping is disabled, allow SA
                // groups with an empty SA number so records are shown
                // when flattened.
                if (
                  (groupByServiceAppointment && !saNumber) ||
                  !Array.isArray(visibleSaRecords) ||
                  visibleSaRecords.length === 0
                ) {
                  return null;
                }

                return {
                  ...sa,
                  data: visibleSaRecords,
                };
              })
              .filter(Boolean);

            if (visibleSaGroups.length === 0) {
              return null;
            }

            return {
              ...woli,
              data: visibleSaGroups,
            };
          })
          .filter(Boolean);

        if (visibleWoli.length === 0) {
          return null;
        }

        return {
          ...page,
          data: visibleWoli,
        };
      })
      .filter(Boolean);

  extractedData = pruneEmptyWorkOrders(extractedData);
  const currentItemsUsers = extractedData.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  const hasPageResults = currentItemsUsers.some(
    (page) => (page.data || []).some((woli) => (woli.data || []).some((sa) => (sa.data || []).length > 0)),
  );

  //Array of total id's (250) of sliced data to use Select All button.
  // currentItemsUsers.forEach((item) => {
  //   arrayWoli = arrayWoli.concat(
  //     item.data.flatMap((innerItem) => innerItem.data),
  //   );
  // });

  if (updateFlag === "true") {
    if (
      saCaseNumber != null ||
      ptwNumber != null ||
      saOrderNumber != null ||
      searchMetaDataKey != null ||
      searchMetaDataValue != null ||
      saAccount != null ||
      saCart != null
    ) {
      return (
        <>
          <ErrorDisplay
            errorMessage={errorMessage}
            unavailable={unavailable}
            onClose={onClose}
          />
          {errorMessage === "" && unavailable !== true && (
            <section>
              <div className="imageGrid">
                <div className="headerContainer">
                  <div className="headerRow">
                    <div className="headerLeft">
                      <h4>
                        {ptwNumber
                          ? "PTW Number : " + ptwNumber
                          : saCaseNumber
                            ? "Salesforce Case Number : " + saCaseNumber
                            : saOrderNumber
                              ? "Salesforce Order Number: " + saOrderNumber
                              : searchMetaDataKey
                                ? searchMetaDataKey +
                                  " : " +
                                  searchMetaDataValue
                                : saCart
                                  ? "Salesforce Cart: " + saCart
                                  : saAccount
                                    ? "Salesforce Account: " + saAccount
                                    : null}
                      </h4>
                    </div>
                    <div className="headerTop">
                      {archivedImages.some(
                        (img) => img.isFileArchived === "true",
                      ) && (
                        <button
                          className="btn-download btn-reArchive"
                          onClick={() =>
                            handleReArchive(
                              loaderdiv,
                              loaderOverlaydiv,
                              axios,
                              accessToken,
                              createDialogBox,
                              closeDialogBox,
                              downloadImages,
                              listThumbnails,
                              setDownloadImages,
                              setArchivedImages,
                              setListThumbnails,
                              setIsCheck,
                              setIsCheckAll,
                            )
                          }
                          // disabled={
                          //   !archivedImages.every(
                          //     (img) => img.isFileArchived === "true"
                          //   )
                          // }
                        >
                          Restore from archive
                        </button>
                      )}
                    </div>
                    <div className="headerActions">
                      <SelectAllCheckbox
                        isChecked={isCheckAll}
                        onChange={genHandleSelectAll}
                      />
                      <GenericDownloadButton
                        downloadImages={downloadImages}
                        isCheckAll={isCheckAll}
                        genImgUri={genImgUri}
                        setIsCheck={setIsCheck}
                        setIsCheckAll={setIsCheckAll}
                        setDownloadImages={setDownloadImages}
                        setArchivedImages={setArchivedImages}
                      />
                    </div>
                    <div className="submitShowOnWeb">
                      <button
                        type="button"
                        className={`btn-download ${
                          isSubmitButtonDisabled ? " " : "disabled"
                        }`}
                        onClick={handleShowOnWebForSFCaseNumberClick}
                        disabled={!isSubmitButtonDisabled}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
                <div className="woli">
                  <div>
                   {isLoading ? (
                      <Loader message="Loading gallery items..." />
                    ) : null}
                    {!isLoading && (
                    <ol type="1" className="users">
                      {/* {currentItemsGenUsers.map((user) => {  */}
                      {filteredDirectUsers.map((user, userIndex) => {
                        const {
                          id,
                          fileName,
                          originalFileName,
                          fileUploadedDateTime,
                          fileExtension,
                          fileSize,
                          sourceSystem,
                          fileURI,
                          fileFinalURL,
                          fileThumbnailURI,
                          metaData,
                          imageAttributes,
                          showOnWeb,
                          isFileArchived,
                        } = user;
                        var showFileURL = fileFinalURL;
                        const validExtensions = [
                          "png",
                          "jpg",
                          "jpeg",
                          "heif",
                          "heic",
                        ];
                        const checkExtension =
                          fileExtension && fileExtension.includes(".")
                            ? fileExtension.split(".").pop()
                            : fileExtension || "";
                        if (
                          validExtensions.includes(checkExtension.toLowerCase())
                        ) {
                          return (
                            <li key={id}>
                              <div className="check">
                                <label className="cont">
                                  <input
                                    key={id}
                                    id={id}
                                    type="checkbox"
                                    className="box"
                                    value={
                                      fileFinalURL + genericStorageSasToken
                                    }
                                    checked={isCheck.includes(id)}
                                    onChange={(e) => {
                                      handleClick(e);
                                      const isChecked = e.target.checked;
                                      const fileData =
                                        e.target.value +
                                        "$" +
                                        fileName +
                                        "$" +
                                        fileExtension +
                                        "$" +
                                        (fileSize || "");
                                      if (isChecked) {
                                        handleAdd(fileData, isFileArchived);
                                        handleAddThumb(fileThumbnailURI);
                                        if (downloaded === true) {
                                          handleClick(e);
                                        }
                                      } else {
                                        handleRemove(fileData);
                                        handleRemoveThumb(fileThumbnailURI);
                                      }
                                    }}
                                  ></input>
                                </label>
                              </div>
                              <LazyLoadImage
                                effect="blur"
                                delayTime={100}
                                threshold={500}
                                src={
                                  imageError[id]
                                    ? isFileArchived === "true"
                                      ? archiveIcon
                                      : failedToLoad
                                    : fileThumbnailURI
                                      ? fileThumbnailURI +
                                        genericStorageSasToken
                                      : fileFinalURL + genericStorageSasToken
                                }
                                alt={originalFileName}
                                onError={() => handleImageError(id)}
                                onClick={() => {
                                  setOcrData(
                                    // {currentItemsGenUsers.map((blob) => {
                                    filteredDirectUsers.map((blob) => {
                                      // return (blob.imageAttributes && blob.imageAttributes[0].ocrData) || [];
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.ocrData) ||
                                        []
                                      );
                                    }),
                                  );
                                  setCapturedDate(
                                    // {currentItemsGenUsers.map((blob) => {
                                    filteredDirectUsers.map((blob) => {
                                      // return (blob.imageAttributes && blob.imageAttributes[0].dateOnImage) || [];
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.dateOnImage) ||
                                        []
                                      );
                                    }),
                                  );
                                  setDbInsertedDateTime(
                                    filteredDirectUsers.map((blob) => {
                                      return blob.dbInsertedDateTime;
                                    }),
                                  );
                                  setDateTime(
                                    // {currentItemsGenUsers.map((blob) => {
                                    filteredDirectUsers.map((blob) => {
                                      return blob.fileUploadedDateTime;
                                    }),
                                  );
                                  setLat(
                                    // {currentItemsGenUsers.map((blob) => {
                                    genUsers.map((blob) => {
                                      // return (blob.imageAttributes && blob.imageAttributes[0].coordinates[0].latitude) || [];
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.coordinates &&
                                          blob.imageAttributes.coordinates
                                            .latitude) ||
                                        []
                                      );
                                    }),
                                  );
                                  setLong(
                                    // {currentItemsGenUsers.map((blob) => {
                                    genUsers.map((blob) => {
                                      // return (blob.imageAttributes && blob.imageAttributes[0].coordinates[0].longitude) || [];
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.coordinates &&
                                          blob.imageAttributes.coordinates
                                            .longitude) ||
                                        []
                                      );
                                    }),
                                  );
                                  setPhotoIndex(userIndex);
                                  setIsOpenImage(true);
                                  setBlobUrls(
                                    // {currentItemsGenUsers.map((blob) => {
                                    filteredDirectUsers.map((blob) => {
                                      return (
                                        blob.fileFinalURL +
                                        genericStorageSasToken
                                      );
                                    }),
                                  );
                                }}
                              />
                              <p>
                                <div
                                  className="metadata imgInfo"
                                  style={{ float: "left" }}
                                >
                                  <div className="row">
                                    <b>File No.:</b>
                                    <span>{userIndex + 1}</span>
                                  </div>

                                  <div className="row">
                                    <b>File Name:</b>
                                    <span>
                                      {fileName
                                        ? fileName.includes(".")
                                          ? fileName
                                          : fileName +
                                            (fileExtension.includes(".")
                                              ? fileExtension
                                              : "." + fileExtension)
                                        : originalFileName}
                                    </span>
                                  </div>

                                  <div className="row">
                                    <b>Captured Date:</b>
                                    <span>
                                      {imageAttributes
                                        ? imageAttributes.dateOnImage
                                          ? imageAttributes.dateOnImage
                                          : "NA"
                                        : "NA"}
                                    </span>
                                  </div>

                                  <div className="row">
                                    <b>Gps Loc.:</b>
                                    <span>
                                      {imageAttributes &&
                                      imageAttributes.coordinates
                                        ? (imageAttributes.coordinates
                                            .longitude == null
                                            ? "0.00"
                                            : imageAttributes.coordinates
                                                .longitude) +
                                          "   " +
                                          (imageAttributes.coordinates
                                            .latitude == null
                                            ? "0.00"
                                            : imageAttributes.coordinates
                                                .latitude)
                                        : "NA"}
                                    </span>
                                  </div>

                                  <div className="row">
                                    <b>Source System:</b>
                                    <span>{sourceSystem}</span>
                                  </div>
                                </div>

                                {showOnWeb === "true" &&
                                isFileArchived !== "true" ? (
                                  <label className="showOnwebLabel">
                                    <input
                                      type="checkbox"
                                      name={"selectShowOnWebName"}
                                      id={id}
                                      data-file-name={
                                        fileName
                                          ? fileName.includes(".")
                                            ? fileName
                                            : fileName +
                                              (fileExtension.includes(".")
                                                ? fileExtension
                                                : "." + fileExtension)
                                          : originalFileName
                                      }
                                      className="firstShowOnWebbox"
                                      checked={showOnWebChecked[id]}
                                      onChange={(event) =>
                                        handleShowOnWebChange(
                                          id,
                                          event.target.checked,
                                        )
                                      }
                                    />
                                    &nbsp;&nbsp;Show on website
                                  </label>
                                ) : (showOnWeb === "false" ||
                                    showOnWeb === "") &&
                                  isFileArchived !== "true" ? (
                                  <label className="showOnwebLabel">
                                    <input
                                      type="checkbox"
                                      name={"selectShowOnWebName"}
                                      id={id}
                                      data-file-name={
                                        fileName
                                          ? fileName.includes(".")
                                            ? fileName
                                            : fileName +
                                              (fileExtension.includes(".")
                                                ? fileExtension
                                                : "." + fileExtension)
                                          : originalFileName
                                      }
                                      className="firstShowOnWebbox"
                                      onChange={(event) =>
                                        handleShowOnWebChangeForChecked(
                                          id,
                                          event.target.checked,
                                        )
                                      }
                                    />
                                    &nbsp;&nbsp;Show on website
                                  </label>
                                ) : null}
                                {/* Release 4.1 */}
                              </p>
                            </li>
                          );
                        } else {
                          return (
                            <li className="docs" key={fileFinalURL}>
                              <div className="check">
                                <label className="cont">
                                  <input
                                    key={id}
                                    id={id}
                                    type="checkbox"
                                    className="box"
                                    value={
                                      fileFinalURL + genericStorageSasToken
                                    }
                                    checked={isCheck.includes(id)}
                                    onChange={(e) => {
                                      handleClick(e);
                                      const isChecked = e.target.checked;
                                      const fileData =
                                        e.target.value +
                                        "$" +
                                        fileName +
                                        "$" +
                                        fileExtension +
                                        "$" +
                                        (fileSize || "");
                                      if (isChecked) {
                                        handleAdd(fileData, isFileArchived);
                                        handleAddThumb(fileThumbnailURI);
                                        if (downloaded === true) {
                                          handleClick(e);
                                        }
                                      } else {
                                        handleRemove(fileData);
                                        handleRemoveThumb(fileThumbnailURI);
                                      }
                                    }}
                                  ></input>
                                </label>
                              </div>
                              <LazyLoadImage
                                effect="blur"
                                delayTime={100}
                                threshold={500}
                                src={
                                  isFileArchived === "true"
                                    ? archiveIcon
                                    : fileThumbnailURI + genericStorageSasToken
                                }
                                alt={originalFileName}
                                onError={() => handleImageError(id)}
                                onClick={() => {
                                  setOcrData(
                                    filteredDirectUsers.map((blob) => {
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.ocrData) || []
                                      );
                                    }),
                                  );
                                  setCapturedDate(
                                    filteredDirectUsers.map((blob) => {
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.dateOnImage) ||
                                        []
                                      );
                                    }),
                                  );
                                  setDbInsertedDateTime(
                                    filteredDirectUsers.map((blob) => {
                                      return blob.dbInsertedDateTime;
                                    }),
                                  );
                                  setDateTime(
                                    filteredDirectUsers.map((blob) => {
                                      return blob.fileUploadedDateTime;
                                    }),
                                  );
                                  setLat(
                                    genUsers.map((blob) => {
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.coordinates &&
                                          blob.imageAttributes.coordinates
                                            .latitude) ||
                                        []
                                      );
                                    }),
                                  );
                                  setLong(
                                    genUsers.map((blob) => {
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.coordinates &&
                                          blob.imageAttributes.coordinates
                                            .longitude) ||
                                        []
                                      );
                                    }),
                                  );
                                  setPhotoIndex(userIndex);
                                  setIsOpenImage(true);
                                  setBlobUrls(
                                    filteredDirectUsers.map((blob) => {
                                      return (
                                        blob.fileFinalURL +
                                        genericStorageSasToken
                                      );
                                    }),
                                  );
                                  setFiledesc(
                                    filteredDirectUsers.map((blob) => {
                                      return blob.fileDescription;
                                    }),
                                  );
                                }}
                              />
                              <div
                                className="metadata imgInfo"
                                style={{ float: "left" }}
                              >
                                <div className="row">
                                  <b>File No.:</b>
                                  <span>{genUsers.indexOf(user) + 1}</span>
                                </div>

                                <div className="row">
                                  <b>File Name:</b>
                                  <span>
                                    {fileName
                                      ? fileName.includes(".")
                                        ? fileName
                                        : fileName +
                                          (fileExtension.includes(".")
                                            ? fileExtension
                                            : "." + fileExtension)
                                      : originalFileName}
                                  </span>
                                </div>

                                <div className="row">
                                  <b>Captured Date:</b>
                                  <span>
                                    {imageAttributes
                                      ? imageAttributes.dateOnImage
                                        ? imageAttributes.dateOnImage
                                        : "NA"
                                      : "NA"}
                                  </span>
                                </div>

                                <div className="row">
                                  <b>Gps Loc.:</b>
                                  <span>
                                    {imageAttributes &&
                                    imageAttributes.coordinates
                                      ? (imageAttributes.coordinates
                                          .longitude == null
                                          ? "0.00"
                                          : imageAttributes.coordinates
                                              .longitude) +
                                        "   " +
                                        (imageAttributes.coordinates.latitude ==
                                        null
                                          ? "0.00"
                                          : imageAttributes.coordinates
                                              .latitude)
                                      : "NA"}
                                  </span>
                                </div>

                                <div className="row">
                                  <b>Source System:</b>
                                  <span>{sourceSystem}</span>
                                </div>
                              </div>
                            </li>
                          );
                        }
                      })}
                      {isOpenImage && (
                        <Lightbox
                          animationOnKeyInput={true}
                          clickOutsideToClose={false}
                          // imageTitle={`Salesforce Case No. :\u00A0\u00A0${saCaseNumber}`}
                          imageTitle={
                            ptwNumber
                              ? "PTW Number : " + ptwNumber
                              : saCaseNumber
                                ? "Salesforce Case Number : " + saCaseNumber
                                : searchMetaDataKey
                                  ? searchMetaDataKey +
                                    " : " +
                                    searchMetaDataValue
                                  : saOrderNumber
                                    ? "Salesforce Order Number: " +
                                      saOrderNumber
                                    : saCart
                                      ? "Salesforce Cart: " + saCart
                                      : saAccount
                                        ? "Salesforce Account: " + saAccount
                                        : null
                          }
                          toolbarButtons={customButtons}
                          imageCaption={
                            isCaptionVisible
                              ? `GPS Loc :\u00A0\u00A0${
                                  (lat[photoIndex] == null
                                    ? "NA"
                                    : lat[photoIndex]) +
                                  "\xa0\xa0\xa0\xa0\xa0" +
                                  (long[photoIndex] == null
                                    ? ""
                                    : long[photoIndex])
                                }\u00A0;\u00A0                      
                        CapturedDate :\u00A0\u00A0${
                          capturedDate[photoIndex] == null
                            ? "NA"
                            : capturedDate[photoIndex]
                        }\u00A0;\u00A0
                        UploadedDate :\u00A0\u00A0${
                          dateTime[photoIndex] == null
                            ? "NA"
                            : dateTime[photoIndex]
                        }\u00A0;\u00A0                       
                        OCR Data :\u00A0\u00A0${ocrData[photoIndex]}\u00A0\u00A0
                        `
                              : ``
                          }
                          mainSrc={blobUrls[photoIndex]}
                          mainSrcThumbnail={blobUrls[photoIndex]}
                          imagePadding={100}
                          nextSrc={blobUrls[(photoIndex + 1) % blobUrls.length]}
                          prevSrc={
                            blobUrls[
                              (photoIndex + blobUrls.length - 1) %
                                blobUrls.length
                            ]
                          }
                          onCloseRequest={() => {
                            setIsCaptionVisible(false);
                            setIsOpenImage(false);
                            return;
                          }}
                          onMovePrevRequest={handleMovePrevRequest}
                          onMoveNextRequest={handleMoveNextRequest}
                        />
                      )}
                    </ol>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
        </>
      );
    } else {
      if (recordType === "Site" || recordType === "Patch") {
        return (
          <>
            <ErrorDisplay
              errorMessage={errorMessage}
              unavailable={unavailable}
              onClose={onClose}
            />

            {errorMessage === "" && unavailable !== true && (
              <section>
                <div className="imageGrid">
                  <div className="headerContainer">
                    <div className="headerRow">
                      <div className="headerLeft">
                        <h4>Work Order: {workdIds[0]}</h4>
                      </div>
                      <div className="headerTop">
                        {archivedImages.some(
                          (img) => img.isFileArchived === "true",
                        ) && (
                          <button
                            className="btn-download btn-reArchive"
                            onClick={() =>
                              handleReArchive(
                                loaderdiv,
                                loaderOverlaydiv,
                                axios,
                                accessToken,
                                createDialogBox,
                                closeDialogBox,
                                downloadImages,
                                listThumbnails,
                                setDownloadImages,
                                setArchivedImages,
                                setListThumbnails,
                                setIsCheck,
                                setIsCheckAll,
                              )
                            }
                          >
                            Restore from archive
                          </button>
                        )}
                      </div>
                      <div className="headerActions">
                        <SelectAllCheckbox
                          isChecked={isCheckAll}
                          onChange={handleSelectAll}
                        />

                        {downloadButton}
                        
                      </div>
                      <div className="submitShowOnWeb">
                        <button
                          type="button"
                          className={`btn-download ${
                            isSubmitButtonDisabled ? " " : "disabled"
                          }`}
                          onClick={handleShowOnWebClick}
                          disabled={!isSubmitButtonDisabled}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                  {Object.entries(filteredUsersReinstatement).map(
                    ([siteKey, siteValue]) => {
                      return (
                        <li key={siteKey} className="siteName">
                          {siteKey && (
                            <div className="siteNameBar">
                              <h4>
                                <button
                                  className="siteNameButton"
                                  onClick={() =>
                                    toggleSiteExpansion(
                                      siteKey,
                                      setExpansionState,
                                    )
                                  }
                                >
                                  {expansionState[siteKey]?.site ? "-" : "+"}
                                </button>
                                Site name: {siteKey}
                              </h4>
                            </div>
                          )}
                          {expansionState[siteKey]?.site && (
                            <div className="patchNameBar">
                              {Object.entries(siteValue).map(
                                ([patchKey, patchValue]) => {
                                  return (
                                    <div key={patchKey}>
                                      {patchKey && (
                                        <div className="patchNameItem">
                                          <h4>
                                            <button
                                              className="patchNameButton"
                                              onClick={() =>
                                                togglePatchExpansion(
                                                  siteKey,
                                                  patchKey,
                                                  setExpansionState,
                                                )
                                              }
                                            >
                                              {expansionState[siteKey]?.[
                                                patchKey
                                              ]?.patch
                                                ? "-"
                                                : "+"}
                                            </button>
                                            Patch name: {patchKey}
                                          </h4>
                                        </div>
                                      )}
                                      {expansionState[siteKey]?.[patchKey]
                                        ?.patch && (
                                        <li className="woli">
                                          {Object.entries(patchValue).map(
                                            ([workTypeKey, workTypeValue]) => {
                                              return Object.entries(
                                                workTypeValue,
                                              ).map(([woliKey, woliValue]) => {
                                                return (
                                                  <div>
                                                    <div key={woliKey}>
                                                      <h5 className="workLine">
                                                        Work type: {workTypeKey}
                                                      </h5>
                                                      <h5 className="workLine">
                                                        WOLI: {woliKey}
                                                      </h5>
                                                    </div>
                                                    {Object.entries(
                                                      woliValue,
                                                    ).map(
                                                      ([saKey, saValue]) => {
                                                        //{woliValue.map((item) => (
                                                        return (
                                                          <div key={saKey}>
                                                            <h6 className="sa">
                                                              SA: {saKey}
                                                            </h6>
                                                            <div className="sa-flex-row">
                                                              <ol
                                                                type="1"
                                                                className="users"
                                                              >
                                                              {renderImageListItemsForShowOnWeb(
                                                                  saValue,
                                                                  downloadProgress,
                                                                  handleDownloadClick,
                                                                )}
                                                              </ol>
                                                            </div>
                                                          </div>
                                                        );
                                                      },
                                                    )}
                                                  </div>
                                                );
                                              });
                                            },
                                          )}
                                        </li>
                                      )}
                                      {!patchKey && (
                                        <li className="woliWithoutPatch">
                                          {Object.entries(patchValue).map(
                                            ([workTypeKey, workTypeValue]) => {
                                              return Object.entries(
                                                workTypeValue,
                                              ).map(([woliKey, woliValue]) => {
                                                return (
                                                  <div>
                                                    <div key={woliKey}>
                                                      <h5 className="workLine">
                                                        Work type: {workTypeKey}
                                                      </h5>
                                                      <h5 className="workLine">
                                                        WOLI: {woliKey}
                                                      </h5>
                                                    </div>
                                                    {Object.entries(
                                                      woliValue,
                                                    ).map(
                                                      ([saKey, saValue]) => {
                                                        //{woliValue.map((item) => (
                                                        return (
                                                          <div key={saKey}>
                                                            <h6 className="sa">
                                                              SA: {saKey}
                                                            </h6>
                                                            <div className="sa-flex-row">
                                                              <ol
                                                                type="1"
                                                                className="users"
                                                              >
                                                                {renderImageListItemsForShowOnWeb(
                                                                  saValue,
                                                                  downloadProgress,
                                                                  handleDownloadClick,
                                                                )}
                                                              </ol>
                                                            </div>
                                                          </div>
                                                        );
                                                      },
                                                    )}
                                                  </div>
                                                );
                                              });
                                            },
                                          )}
                                        </li>
                                      )}
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          )}
                          {!siteKey && (
                            <div className="patchNameBar">
                              {Object.entries(siteValue).map(
                                ([patchKey, patchValue]) => {
                                  return (
                                    <div key={patchKey}>
                                      {patchKey && (
                                        <div className="patchNameItem">
                                          <h4>
                                            <button
                                              className="patchNameButton"
                                              onClick={() =>
                                                togglePatchWithoutSiteExpansion(
                                                  patchKey,
                                                  setExpansionState,
                                                )
                                              }
                                            >
                                              {expansionState[patchKey]?.patch
                                                ? "-"
                                                : "+"}
                                            </button>
                                            Patch name: {patchKey}
                                          </h4>
                                        </div>
                                      )}
                                      {expansionState[patchKey]?.patch && (
                                        <li className="woli">
                                          {Object.entries(patchValue).map(
                                            ([workTypeKey, workTypeValue]) => {
                                              return Object.entries(
                                                workTypeValue,
                                              ).map(([woliKey, woliValue]) => {
                                                return (
                                                  <div>
                                                    <div key={woliKey}>
                                                      <h5 className="workLine">
                                                        Work type: {workTypeKey}
                                                      </h5>
                                                      <h5 className="workLine">
                                                        WOLI: {woliKey}
                                                      </h5>
                                                    </div>
                                                    {Object.entries(
                                                      woliValue,
                                                    ).map(
                                                      ([saKey, saValue]) => {
                                                        //{woliValue.map((item) => (
                                                        return (
                                                          <div key={saKey}>
                                                            <h6 className="sa">
                                                              SA: {saKey}
                                                            </h6>
                                                            <div className="sa-flex-row">
                                                              <ol
                                                                type="1"
                                                                className="users"
                                                              >
                                                                {renderImageListItemsForShowOnWeb(
                                                                  saValue,
                                                                  downloadProgress,
                                                                  handleDownloadClick,
                                                                )}
                                                              </ol>
                                                            </div>
                                                          </div>
                                                        );
                                                      },
                                                    )}
                                                  </div>
                                                );
                                              });
                                            },
                                          )}
                                        </li>
                                      )}
                                      {!patchKey && (
                                        <li className="woliWithoutPatch">
                                          {Object.entries(patchValue).map(
                                            ([workTypeKey, workTypeValue]) => {
                                              return Object.entries(
                                                workTypeValue,
                                              ).map(([woliKey, woliValue]) => {
                                                return (
                                                  <div>
                                                    <div key={woliKey}>
                                                      <h5 className="workLine">
                                                        Work type: {workTypeKey}
                                                      </h5>
                                                      <h5 className="workLine">
                                                        WOLI: {woliKey}
                                                      </h5>
                                                    </div>
                                                    {Object.entries(
                                                      woliValue,
                                                    ).map(
                                                      ([saKey, saValue]) => {
                                                        //{woliValue.map((item) => (
                                                        return (
                                                          <div key={saKey}>
                                                            <h6 className="sa">
                                                              SA: {saKey}
                                                            </h6>
                                                            <div className="sa-flex-row">
                                                              <ol
                                                                type="1"
                                                                className="users"
                                                              >
                                                                {renderImageListItemsForShowOnWeb(
                                                                  saValue,
                                                                  downloadProgress,
                                                                  handleDownloadClick,
                                                                )}
                                                              </ol>
                                                            </div>
                                                          </div>
                                                        );
                                                      },
                                                    )}
                                                  </div>
                                                );
                                              });
                                            },
                                          )}
                                        </li>
                                      )}
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          )}
                        </li>
                      );
                    },
                  )}
                  {isOpenImage && openLightbox()}
                </div>
              </section>
            )}
          </>
        );
      } else if (recordType === "Reinstatement_Site_WOLI") {
        return (
          <>
            <ErrorDisplay
              errorMessage={errorMessage}
              unavailable={unavailable}
              onClose={onClose}
            />
            {errorMessage === "" && unavailable !== true && (
              <section>
                <div className="imageGrid">
                  <div className="headerContainer">
                    <div className="headerRow">
                      <div className="headerLeft">
                        <h4>Work Order: {workdIds[0]}</h4>
                      </div>
                      <div className="headerTop">
                        {archivedImages.some(
                          (img) => img.isFileArchived === "true",
                        ) && (
                          <button
                            className="btn-download btn-reArchive"
                            onClick={() =>
                              handleReArchive(
                                loaderdiv,
                                loaderOverlaydiv,
                                axios,
                                accessToken,
                                createDialogBox,
                                closeDialogBox,
                                downloadImages,
                                listThumbnails,
                                setDownloadImages,
                                setArchivedImages,
                                setListThumbnails,
                                setIsCheck,
                                setIsCheckAll,
                              )
                            }
                          >
                            Restore from archive
                          </button>
                        )}
                      </div>
                      <div className="headerActions">
                        <SelectAllCheckbox
                          isChecked={isCheckAll}
                          onChange={handleSelectAll}
                        />

                        {downloadButton}
                      </div>
                      <div className="submitShowOnWeb">
                        <button
                          type="button"
                          className={`btn-download ${
                            isSubmitButtonDisabled ? " " : "disabled"
                          }`}
                          onClick={handleShowOnWebClick}
                          disabled={!isSubmitButtonDisabled}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                  {Object.entries(filteredUsersReinstatement).map(
                    ([siteKey, siteValue]) => {
                      return (
                        <li key={siteKey} className="siteName">
                          <div className="siteNameBar">
                            <h4>
                              <button
                                className="siteNameButton"
                                onClick={() =>
                                  toggleSiteExpansion(
                                    siteKey,
                                    setExpansionState,
                                  )
                                }
                              >
                                {expansionState[siteKey]?.site ? "-" : "+"}
                              </button>
                              Site name: {siteKey}
                            </h4>
                          </div>
                          {expansionState[siteKey]?.site && (
                            <div className="workTypeBar">
                              {Object.entries(siteValue).map(
                                ([workTypeKey, workTypeValue]) => {
                                  return (
                                    <div key={workTypeKey}>
                                      {workTypeKey && (
                                        <div className="workTypeItem">
                                          <h4>
                                            <button
                                              className="workTypeButton"
                                              onClick={() =>
                                                toggleWorkTypeExpansion(
                                                  siteKey,
                                                  workTypeKey,
                                                  setExpansionState,
                                                )
                                              }
                                            >
                                              {expansionState[siteKey]?.[
                                                workTypeKey
                                              ]?.workType
                                                ? "-"
                                                : "+"}
                                            </button>
                                            Work type: {workTypeKey}
                                          </h4>
                                        </div>
                                      )}
                                      {expansionState[siteKey]?.[workTypeKey]
                                        ?.workType && (
                                        <li className="woli">
                                          {Object.entries(workTypeValue).map(
                                            ([woliKey, woliValue]) => {
                                              return (
                                                <div>
                                                  <div key={woliKey}>
                                                    <h5 className="workLine">
                                                      WOLI: {woliKey}
                                                    </h5>
                                                  </div>
                                                  {Object.entries(
                                                    woliValue,
                                                  ).map(([saKey, saValue]) => {
                                                    //{woliValue.map((item) => (
                                                    return (
                                                      <div key={saKey}>
                                                        <h6 className="sa">
                                                          SA: {saKey}
                                                        </h6>
                                                        <div className="sa-flex-row">
                                                          <ol
                                                            type="1"
                                                            className="users"
                                                          >
                                                            {renderImageListItemsForShowOnWeb(
                                                              saValue,
                                                              downloadProgress,
                                                              handleDownloadClick,
                                                            )}
                                                          </ol>
                                                        </div>
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              );
                                            },
                                          )}
                                        </li>
                                      )}
                                      {!workTypeKey && (
                                        <li className="woliWithoutWorkType">
                                          {Object.entries(workTypeValue).map(
                                            ([woliKey, woliValue]) => {
                                              return (
                                                <div>
                                                  <div key={woliKey}>
                                                    <h5 className="workLine">
                                                      WOLI: {woliKey}
                                                    </h5>
                                                  </div>
                                                  {Object.entries(
                                                    woliValue,
                                                  ).map(([saKey, saValue]) => {
                                                    //{woliValue.map((item) => (
                                                    return (
                                                      <div key={saKey}>
                                                        <h6 className="sa">
                                                          SA: {saKey}
                                                        </h6>
                                                        <div className="sa-flex-row">
                                                          <ol
                                                            type="1"
                                                            className="users"
                                                          >
                                                            {renderImageListItemsForShowOnWeb(
                                                              saValue,
                                                              downloadProgress,
                                                              handleDownloadClick,
                                                            )}
                                                          </ol>
                                                        </div>
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              );
                                            },
                                          )}
                                        </li>
                                      )}
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          )}
                        </li>
                      );
                    },
                  )}
                  {isOpenImage && openLightbox()}
                </div>
              </section>
            )}
          </>
        );
      } else {
        return (
          <>
            <ErrorDisplay
              errorMessage={errorMessage}
              unavailable={unavailable}
              onClose={onClose}
            />

            {errorMessage === "" && unavailable !== true && (
              <section>
                <div className="imageGrid">
                  <div className="headerContainer">
                    <div className="headerRow">
                      <div className="headerLeft">
                        <h4>Work Order: {workdIds[0]}</h4>
                      </div>
                      <div className="headerTop">
                        {archivedImages.some(
                          (img) => img.isFileArchived === "true",
                        ) && (
                          <button
                            className="btn-download btn-reArchive"
                            onClick={() =>
                              handleReArchive(
                                loaderdiv,
                                loaderOverlaydiv,
                                axios,
                                accessToken,
                                createDialogBox,
                                closeDialogBox,
                                downloadImages,
                                listThumbnails,
                                setDownloadImages,
                                setArchivedImages,
                                setListThumbnails,
                                setIsCheck,
                                setIsCheckAll,
                              )
                            }
                          >
                            Restore from archive
                          </button>
                        )}
                      </div>
                      <div className="headerActions">
                        <SelectAllCheckbox
                          isChecked={isCheckAll}
                          onChange={handleSelectAll}
                        />

                        <DownloadButton
                          isCheckAll={isCheckAll}
                          setIsCheckAll={setIsCheckAll}
                          isCheck={isCheck}
                          setIsCheck={setIsCheck}
                          ImgUri={ImgUri}
                          downloadProgress={downloadProgress}
                          setDownloadProgress={setDownloadProgress}
                          downloadImages={downloadImages}
                          wo={workdIds[0]}
                          totalCount={arrayWoli.length}
                          setDownloadImages={setDownloadImages}
                          setArchivedImages={setArchivedImages}
                          createDialogBox={createDialogBox}
                          closeDialogBox={closeDialogBox}
                          accessToken={accessToken}
                          setIsDownloadSidebarVisible={
                          setIsDownloadSidebarVisible
                          }
                        />
                        <div className="submitShowOnWeb">
                          <button
                            type="button"
                            className={`btn-download ${
                              isSubmitButtonDisabled ? " " : "disabled"
                            }`}
                            onClick={handleShowOnWebClick}
                            disabled={!isSubmitButtonDisabled}
                          >
                            Submit
                          </button>
                        </div>
                        <GalleryControlsBar
                          isGalleryControlsOpen={isGalleryControlsOpen}
                          setIsGalleryControlsOpen={setIsGalleryControlsOpen}
                          closeGalleryControls={closeGalleryControls}
                          galleryControlsMode={galleryControlsMode}
                          openGalleryControls={openGalleryControls}
                          sortOption={sortOption}
                          handleSortChange={handleSortChange}
                          groupByServiceAppointment={groupByServiceAppointment}
                          toggleGroupByServiceAppointment={toggleGroupByServiceAppointment}
                          showGroupByServiceAppointment={isWoliSearch}
                          selectedFileTypeGroups={selectedFileTypeGroups}
                          toggleFileTypeGroup={toggleFileTypeGroup}
                          capturedDateFrom={capturedDateFrom}
                          handleCapturedDateFromChange={
                            handleCapturedDateFromChange
                          }
                          capturedDateTo={capturedDateTo}
                          handleCapturedDateToChange={handleCapturedDateToChange}
                          isSingleDateMode={isSingleDateMode}
                          handleSingleDateModeChange={handleSingleDateModeChange}
                          includeNoCapturedDate={includeNoCapturedDate}
                          handleIncludeNoCapturedDateChange={
                            handleIncludeNoCapturedDateChange
                          }
                        selectedEngineers={selectedEngineers}
                        toggleEngineerSelection={toggleEngineerSelection}
                        engineerSearch={engineerSearch}
                        setEngineerSearch={setEngineerSearch}
                        engineerOptions={engineerOptions}
                        clearGalleryFilters={clearGalleryFilters}
                          showSidebar={false}
                        />                         
                      </div>
                    </div>                    
                  </div>
                  <div className="galleryResultsWithSidebar">
                    <div className="galleryResultsColumn">
                  {hasVisibleGalleryResults && hasPageResults ? (
                  <div className="woli">
                    {currentItemsUsers.map((page, pageIndex) =>
                      page.data.map((woli, woliIndex) => {
                        const visibleSaGroups = woli.data
                          .map((sa, saIndex) => {
                            const saNumber = (sa.serviceAppointmentNumber || "")
                              .toString()
                              .trim();
                            const visibleSaRecords =
                              selectedEngineers.length > 0
                                ? sa.data.filter(recordMatchesSelectedEngineer)
                                : sa.data;

                            if (
                              !Array.isArray(visibleSaRecords) ||
                              visibleSaRecords.length === 0
                            ) {
                              return null;
                            }

                            return {
                              key: `${woli.workOrderLineItemNumber}-${saNumber}-${saIndex}`,
                              saNumber,
                              visibleSaRecords,
                            };
                          })
                          .filter(Boolean);

                        if (visibleSaGroups.length === 0) {
                          return null;
                        }

                        return (
                          <div
                            key={`${woli.workOrderLineItemNumber}-${pageIndex}-${woliIndex}`}
                          >
                            <h5 className="workLine">
                              WOLI&nbsp;:&nbsp;&nbsp;&nbsp;
                              {woli.workOrderLineItemNumber}
                            </h5>
                            <p></p>
                            {visibleSaGroups.map((saGroup) => (
                              <div key={saGroup.key}>
                                <h6 className="sa">
                                  SA No.&nbsp;:&nbsp;&nbsp;&nbsp;
                                  {saGroup.saNumber || sa || saNo || (saGroup.visibleSaRecords && saGroup.visibleSaRecords[0] && saGroup.visibleSaRecords[0].serviceAppointmentNumber)}
                                </h6>
                                <br></br>
                                <div className="sa-flex-row">
                                  <ol type="1" className="users">
                                    {renderImageListItemsForShowOnWeb(
                                      saGroup.visibleSaRecords,
                                      downloadProgress,
                                      handleDownloadClick,
                                    )}
                                  </ol>
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      }),
                    )}
                    {isOpenImage && openLightbox()}
                    <PaginationUsers
                      extractedData={extractedData}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      isCheckAll={setIsCheckAll}
                    />
                  </div>
                  ) : (
                    <div className="galleryNoItemsShell">
                      {renderNoItemsState()}
                    </div>
                  )}
                  </div>
                  {isDownloadSidebarVisible && renderDownloadSidebar()}
                  {isGalleryControlsOpen && renderGalleryControlsSidebar()}
                  </div>
                </div>
              </section>
            )}
          </>
        );
      }
    }
  } else {
    if (
      saCaseNumber != null ||
      ptwNumber != null ||
      saOrderNumber != null ||
      searchMetaDataKey != null ||
      searchMetaDataValue != null ||
      saAccount != null ||
      saCart != null
    ) {
      return (
        <>
          <ErrorDisplay
            errorMessage={errorMessage}
            unavailable={unavailable}
            onClose={onClose}
          />
          {errorMessage === "" && unavailable !== true && (
            <section>
              <div className="imageGrid">
                <div className="headerContainer">
                  <div className="headerRow">
                    <div className="headerLeft">
                      <h4>
                        {ptwNumber
                          ? "PTW Number : " + ptwNumber
                          : saCaseNumber
                            ? "Salesforce Case Number : " + saCaseNumber
                            : searchMetaDataKey
                              ? searchMetaDataKey + " : " + searchMetaDataValue
                              : saOrderNumber
                                ? "Salesforce Order Number: " + saOrderNumber
                                : saCart
                                  ? "Salesforce Cart: " + saCart
                                  : saAccount
                                    ? "Salesforce Account: " + saAccount
                                    : null}
                      </h4>
                    </div>
                    <div className="headerTop">
                      {archivedImages.some(
                        (img) => img.isFileArchived === "true",
                      ) && (
                        <button
                          className="btn-download btn-reArchive"
                          onClick={() =>
                            handleReArchive(
                              loaderdiv,
                              loaderOverlaydiv,
                              axios,
                              accessToken,
                              createDialogBox,
                              closeDialogBox,
                              downloadImages,
                              listThumbnails,
                              setDownloadImages,
                              setArchivedImages,
                              setListThumbnails,
                              setIsCheck,
                              setIsCheckAll,
                            )
                          }
                        >
                          Restore from archive
                        </button>
                      )}
                    </div>
                    <br></br>
                    <div className="headerActions">
                      <SelectAllCheckbox
                        isChecked={isCheckAll}
                        onChange={genHandleSelectAll}
                      />

                      <GenericDownloadButton
                        downloadImages={downloadImages}
                        isCheckAll={isCheckAll}
                        genImgUri={genImgUri}
                        setIsCheck={setIsCheck}
                        setIsCheckAll={setIsCheckAll}
                        setDownloadImages={setDownloadImages}
                        setArchivedImages={setArchivedImages}
                      />
                    </div>
                  </div>
                </div>
                <div className="woli">
                  <div>
                    {isLoading ? (
                      <Loader message="Loading gallery items..." />
                    ) : null}
                    {!isLoading && (
                    <ol type="1" className="users">
                      {/* {currentItemsGenUsers.map((user) => { */}
                      {filteredDirectUsers.map((user, userIndex) => {
                        const {
                          id,
                          fileName,
                          originalFileName,
                          fileUploadedDateTime,
                          fileExtension,
                          fileSize,
                          sourceSystem,
                          fileURI,
                          fileFinalURL,
                          fileThumbnailURI,
                          metaData,
                          imageAttributes,
                          isFileArchived,
                        } = user;
                        var showFileURL = fileFinalURL;
                        const validExtensions = [
                          "png",
                          "jpg",
                          "jpeg",
                          "heif",
                          "heic",
                        ];
                        const checkExtension =
                          fileExtension && fileExtension.includes(".")
                            ? fileExtension.split(".").pop()
                            : fileExtension || "";
                        if (
                          validExtensions.includes(checkExtension.toLowerCase())
                        ) {
                          return (
                            <li key={id}>
                              <div className="check">
                                <label className="cont">
                                  <input
                                    key={id}
                                    id={id}
                                    type="checkbox"
                                    className="box"
                                    value={
                                      fileFinalURL + genericStorageSasToken
                                    }
                                    checked={isCheck.includes(id)}
                                    onChange={(e) => {
                                      handleClick(e);
                                      const isChecked = e.target.checked;
                                      const fileData =
                                        e.target.value +
                                        "$" +
                                        fileName +
                                        "$" +
                                        fileExtension +
                                        "$" +
                                        (fileSize || "");
                                      if (isChecked) {
                                        handleAdd(fileData, isFileArchived);
                                        handleAddThumb(fileThumbnailURI);
                                        if (downloaded === true) {
                                          handleClick(e);
                                        }
                                      } else {
                                        handleRemove(fileData);
                                        handleRemoveThumb(fileThumbnailURI);
                                      }
                                    }}
                                  ></input>
                                </label>
                              </div>
                              <LazyLoadImage
                                effect="blur"
                                delayTime={100}
                                threshold={500}
                                src={
                                  imageError[id]
                                    ? isFileArchived === "true"
                                      ? archiveIcon
                                      : failedToLoad
                                    : fileThumbnailURI
                                      ? fileThumbnailURI +
                                        genericStorageSasToken
                                      : fileFinalURL + genericStorageSasToken
                                }
                                alt={originalFileName}
                                onError={() => handleImageError(id)}
                                onClick={() => {
                                  setOcrData(
                                    // currentItemsGenUsers.map((blob) => {
                                    filteredDirectUsers.map((blob) => {
                                      // return (blob.imageAttributes && blob.imageAttributes[0].ocrData) || [];
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.ocrData) ||
                                        []
                                      );
                                    }),
                                  );
                                  setCapturedDate(
                                    // currentItemsGenUsers.map((blob) => {
                                    filteredDirectUsers.map((blob) => {
                                      // return (blob.imageAttributes && blob.imageAttributes[0].dateOnImage) || [];
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.dateOnImage) ||
                                        []
                                      );
                                    }),
                                  );
                                  setDbInsertedDateTime(
                                    filteredDirectUsers.map((blob) => {
                                      return blob.dbInsertedDateTime;
                                    }),
                                  );
                                  setDateTime(
                                    // currentItemsGenUsers.map((blob) => {
                                    filteredDirectUsers.map((blob) => {
                                      return blob.fileUploadedDateTime;
                                    }),
                                  );
                                  setLat(
                                    // currentItemsGenUsers.map((blob) => {
                                    genUsers.map((blob) => {
                                      // return (blob.imageAttributes && blob.imageAttributes[0].coordinates[0].latitude) || [];
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.coordinates &&
                                          blob.imageAttributes.coordinates
                                            .latitude) ||
                                        []
                                      );
                                    }),
                                  );
                                  setLong(
                                    // currentItemsGenUsers.map((blob) => {
                                    genUsers.map((blob) => {
                                      // return (blob.imageAttributes && blob.imageAttributes[0].coordinates[0].longitude) || [];
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.coordinates &&
                                          blob.imageAttributes.coordinates
                                            .longitude) ||
                                        []
                                      );
                                    }),
                                  );
                                  setPhotoIndex(userIndex);
                                  setIsOpenImage(true);
                                  setBlobUrls(
                                    // currentItemsGenUsers.map((blob) => {
                                    filteredDirectUsers.map((blob) => {
                                      return (
                                        blob.fileFinalURL +
                                        genericStorageSasToken
                                      );
                                    }),
                                  );
                                }}
                              />

                              <div
                                className="metadata imgInfo"
                                style={{ float: "left" }}
                              >
                                <div className="row">
                                  <b>File No.:</b>
                                  <span>{userIndex + 1}</span>
                                </div>

                                <div className="row">
                                  <b>File Name:</b>
                                  <span>
                                    {fileName
                                      ? fileName.includes(".")
                                        ? fileName
                                        : fileName +
                                          (fileExtension.includes(".")
                                            ? fileExtension
                                            : "." + fileExtension)
                                      : originalFileName}
                                  </span>
                                </div>

                                <div className="row">
                                  <b>Captured Date:</b>
                                  <span>
                                    {imageAttributes
                                      ? imageAttributes.dateOnImage
                                        ? imageAttributes.dateOnImage
                                        : "NA"
                                      : "NA"}
                                  </span>
                                </div>

                                <div className="row">
                                  <b>Gps Loc.:</b>
                                  <span>
                                    {imageAttributes &&
                                    imageAttributes.coordinates
                                      ? (imageAttributes.coordinates
                                          .longitude == null
                                          ? "0.00"
                                          : imageAttributes.coordinates
                                              .longitude) +
                                        "   " +
                                        (imageAttributes.coordinates.latitude ==
                                        null
                                          ? "0.00"
                                          : imageAttributes.coordinates
                                              .latitude)
                                      : "NA"}
                                  </span>
                                </div>

                                <div className="row">
                                  <b>Source System:</b>
                                  <span>{sourceSystem}</span>
                                </div>
                              </div>
                            </li>
                          );
                        } else {
                          return (
                            <li className="docs" key={fileFinalURL}>
                              <div className="check">
                                <label className="cont">
                                  <input
                                    key={id}
                                    id={id}
                                    type="checkbox"
                                    className="box"
                                    value={
                                      fileFinalURL + genericStorageSasToken
                                    }
                                    checked={isCheck.includes(id)}
                                    onChange={(e) => {
                                      handleClick(e);
                                      const isChecked = e.target.checked;
                                      const fileData =
                                        e.target.value +
                                        "$" +
                                        fileName +
                                        "$" +
                                        fileExtension +
                                        "$" +
                                        (fileSize || "");
                                      if (isChecked) {
                                        handleAdd(fileData, isFileArchived);
                                        handleAddThumb(fileThumbnailURI);
                                        if (downloaded === true) {
                                          handleClick(e);
                                        }
                                      } else {
                                        handleRemove(fileData);
                                        handleRemoveThumb(fileThumbnailURI);
                                      }
                                    }}
                                  ></input>
                                </label>
                              </div>
                              <LazyLoadImage
                                effect="blur"
                                delayTime={100}
                                threshold={500}
                                src={
                                  isFileArchived === "true"
                                    ? archiveIcon
                                    : fileThumbnailURI + genericStorageSasToken
                                }
                                alt={originalFileName}
                                onError={() => handleImageError(id)}
                                onClick={() => {
                                  setOcrData(
                                    filteredDirectUsers.map((blob) => {
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.ocrData) || []
                                      );
                                    }),
                                  );
                                  setCapturedDate(
                                    filteredDirectUsers.map((blob) => {
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.dateOnImage) ||
                                        []
                                      );
                                    }),
                                  );
                                  setDbInsertedDateTime(
                                    filteredDirectUsers.map((blob) => {
                                      return blob.dbInsertedDateTime;
                                    }),
                                  );
                                  setDateTime(
                                    filteredDirectUsers.map((blob) => {
                                      return blob.fileUploadedDateTime;
                                    }),
                                  );
                                  setLat(
                                    genUsers.map((blob) => {
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.coordinates &&
                                          blob.imageAttributes.coordinates
                                            .latitude) ||
                                        []
                                      );
                                    }),
                                  );
                                  setLong(
                                    genUsers.map((blob) => {
                                      return (
                                        (blob.imageAttributes &&
                                          blob.imageAttributes.coordinates &&
                                          blob.imageAttributes.coordinates
                                            .longitude) ||
                                        []
                                      );
                                    }),
                                  );
                                  setPhotoIndex(userIndex);
                                  setIsOpenImage(true);
                                  setBlobUrls(
                                    filteredDirectUsers.map((blob) => {
                                      return (
                                        blob.fileFinalURL +
                                        genericStorageSasToken
                                      );
                                    }),
                                  );
                                  setFiledesc(
                                    filteredDirectUsers.map((blob) => {
                                      return blob.fileDescription;
                                    }),
                                  );
                                }}
                              />
                              <p>
                                <div
                                  className="metadata imgInfo"
                                  style={{ float: "left" }}
                                >
                                  <div className="row">
                                    <b>File No.:</b>
                                    <span>{userIndex + 1}</span>
                                  </div>

                                  <div className="row">
                                    <b>File Name:</b>
                                    <span>
                                      {fileName
                                        ? fileName.includes(".")
                                          ? fileName
                                          : fileName +
                                            (fileExtension.includes(".")
                                              ? fileExtension
                                              : "." + fileExtension)
                                        : originalFileName}
                                    </span>
                                  </div>

                                  <div className="row">
                                    <b>Captured Date:</b>
                                    <span>
                                      {imageAttributes
                                        ? imageAttributes.dateOnImage
                                          ? imageAttributes.dateOnImage
                                          : "NA"
                                        : "NA"}
                                    </span>
                                  </div>

                                  <div className="row">
                                    <b>Gps Loc.:</b>
                                    <span>
                                      {imageAttributes &&
                                      imageAttributes.coordinates
                                        ? (imageAttributes.coordinates
                                            .longitude == null
                                            ? "0.00"
                                            : imageAttributes.coordinates
                                                .longitude) +
                                          "   " +
                                          (imageAttributes.coordinates
                                            .latitude == null
                                            ? "0.00"
                                            : imageAttributes.coordinates
                                                .latitude)
                                        : "NA"}
                                    </span>
                                  </div>

                                  <div className="row">
                                    <b>Source System:</b>
                                    <span>{sourceSystem}</span>
                                  </div>
                                </div>
                              </p>
                            </li>
                          );
                        }
                      })}
                      {isOpenImage && (
                        <Lightbox
                          animationOnKeyInput={true}
                          clickOutsideToClose={false}
                          // imageTitle={`Salesforce Case No. :\u00A0\u00A0${saCaseNumber}`}
                          imageTitle={
                            ptwNumber
                              ? "PTW Number : " + ptwNumber
                              : saCaseNumber
                                ? "Salesforce Case Number : " + saCaseNumber
                                : searchMetaDataKey
                                  ? searchMetaDataKey +
                                    " : " +
                                    searchMetaDataValue
                                  : saOrderNumber
                                    ? "Salesforce Order Number: " +
                                      saOrderNumber
                                    : saCart
                                      ? "Salesforce Cart: " + saCart
                                      : saAccount
                                        ? "Salesforce Account: " + saAccount
                                        : null
                          }
                          toolbarButtons={customButtons}
                          imageCaption={
                            isCaptionVisible
                              ? `GPS Loc :\u00A0\u00A0${
                                  (lat[photoIndex] == null
                                    ? "NA"
                                    : lat[photoIndex]) +
                                  "\xa0\xa0\xa0\xa0\xa0" +
                                  (long[photoIndex] == null
                                    ? ""
                                    : long[photoIndex])
                                }\u00A0;\u00A0                      
                        CapturedDate :\u00A0\u00A0${
                          capturedDate[photoIndex] == null
                            ? "NA"
                            : capturedDate[photoIndex]
                        }\u00A0;\u00A0
                        UploadedDate :\u00A0\u00A0${
                          dateTime[photoIndex] == null
                            ? "NA"
                            : dateTime[photoIndex]
                        }\u00A0;\u00A0                       
                        OCR Data :\u00A0\u00A0${ocrData[photoIndex]}\u00A0\u00A0
                        `
                              : ``
                          }
                          mainSrc={blobUrls[photoIndex]}
                          mainSrcThumbnail={blobUrls[photoIndex]}
                          imagePadding={100}
                          nextSrc={blobUrls[(photoIndex + 1) % blobUrls.length]}
                          prevSrc={
                            blobUrls[
                              (photoIndex + blobUrls.length - 1) %
                                blobUrls.length
                            ]
                          }
                          onCloseRequest={() => {
                            setIsCaptionVisible(false);
                            setIsOpenImage(false);
                            return;
                          }}
                          onMovePrevRequest={handleMovePrevRequest}
                          onMoveNextRequest={handleMoveNextRequest}
                        />
                      )}
                    </ol>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
        </>
      );
    } else {
      if (recordType === "Site" || recordType === "Patch") {
        return (
          <>
            <ErrorDisplay
              errorMessage={errorMessage}
              unavailable={unavailable}
              onClose={onClose}
            />
            {errorMessage === "" && unavailable !== true && (
              <section>
                <div className="imageGrid">
                  <div className="headerContainer">
                    <div className="headerRow">
                      <div className="headerLeft">
                        <h4>Work Order: {workdIds[0]}</h4>
                      </div>

                      <div className="headerTop">
                        {archivedImages.some(
                          (img) => img.isFileArchived === "true",
                        ) && (
                          <button
                            className="btn-download btn-reArchive"
                            onClick={() =>
                              handleReArchive(
                                loaderdiv,
                                loaderOverlaydiv,
                                axios,
                                accessToken,
                                createDialogBox,
                                closeDialogBox,
                                downloadImages,
                                listThumbnails,
                                setDownloadImages,
                                setArchivedImages,
                                setListThumbnails,
                                setIsCheck,
                                setIsCheckAll,
                              )
                            }
                          >
                            Restore from archive
                          </button>
                        )}
                      </div>
                      <div className="headerActions">
                        <SelectAllCheckbox
                          isChecked={isCheckAll}
                          onChange={handleSelectAll}
                        />

                        {downloadButton}
                        {/* <GalleryControlsBar
                          isGalleryControlsOpen={isGalleryControlsOpen}
                          setIsGalleryControlsOpen={setIsGalleryControlsOpen}
                          closeGalleryControls={closeGalleryControls}
                          galleryControlsMode={galleryControlsMode}
                          openGalleryControls={openGalleryControls}
                          sortOption={sortOption}
                          handleSortChange={handleSortChange}
                          groupByServiceAppointment={groupByServiceAppointment}
                          toggleGroupByServiceAppointment={toggleGroupByServiceAppointment}
                          showGroupByServiceAppointment={isWoliSearch}
                          selectedFileTypeGroups={selectedFileTypeGroups}
                          toggleFileTypeGroup={toggleFileTypeGroup}
                          capturedDateFrom={capturedDateFrom}
                          handleCapturedDateFromChange={
                            handleCapturedDateFromChange
                          }
                          capturedDateTo={capturedDateTo}
                          handleCapturedDateToChange={handleCapturedDateToChange}
                          isSingleDateMode={isSingleDateMode}
                          handleSingleDateModeChange={handleSingleDateModeChange}
                          includeNoCapturedDate={includeNoCapturedDate}
                          handleIncludeNoCapturedDateChange={
                            handleIncludeNoCapturedDateChange
                          }
                          selectedEngineers={selectedEngineers}
                          toggleEngineerSelection={toggleEngineerSelection}
                          engineerSearch={engineerSearch}
                          setEngineerSearch={setEngineerSearch}
                          engineerOptions={engineerOptions}
                          clearGalleryFilters={clearGalleryFilters}
                          showSidebar={false}
                        /> */}
                      </div>
                    </div>
                  </div>
                  {Object.keys(filteredUsersReinstatement).length > 0 ? (
                    <div className="sa-flex-row sitePatchControlsLayout">
                      <div className="sitePatchTree">
                        {Object.entries(filteredUsersReinstatement).map(
                          ([siteKey, siteValue]) => {
                      return (
                        <li key={siteKey} className="siteName">
                          {siteKey && (
                            <div className="siteNameBar">
                              <h4>
                                <button
                                  className="siteNameButton"
                                  onClick={() =>
                                    toggleSiteExpansion(
                                      siteKey,
                                      setExpansionState,
                                    )
                                  }
                                >
                                  {expansionState[siteKey]?.site ? "-" : "+"}
                                </button>
                                Site name: {siteKey}
                              </h4>
                            </div>
                          )}
                          {expansionState[siteKey]?.site && (
                            <div className="patchNameBar">
                              {Object.entries(siteValue).map(
                                ([patchKey, patchValue]) => {
                                  return (
                                    <div key={patchKey}>
                                      {patchKey && (
                                        <div className="patchNameItem">
                                          <h4>
                                            <button
                                              className="patchNameButton"
                                              onClick={() =>
                                                togglePatchExpansion(
                                                  siteKey,
                                                  patchKey,
                                                  setExpansionState,
                                                )
                                              }
                                            >
                                              {expansionState[siteKey]?.[
                                                patchKey
                                              ]?.patch
                                                ? "-"
                                                : "+"}
                                            </button>
                                            Patch name: {patchKey}
                                          </h4>
                                        </div>
                                      )}
                                      {expansionState[siteKey]?.[patchKey]
                                        ?.patch && (
                                        <div className="woli">
                                          {Object.entries(patchValue).map(
                                            ([workTypeKey, workTypeValue]) => {
                                              return Object.entries(
                                                workTypeValue,
                                              ).map(([woliKey, woliValue]) => {
                                                return (
                                                  <div>
                                                    <div key={woliKey}>
                                                      <h5 className="workLine">
                                                        Work type: {workTypeKey}
                                                      </h5>
                                                      <h5 className="workLine">
                                                        WOLI: {woliKey}
                                                      </h5>
                                                    </div>
                                                    {Object.entries(
                                                      woliValue,
                                                    ).map(
                                                      ([saKey, saValue]) => {
                                                        //{woliValue.map((item) => (
                                                        return (
                                                          <div key={saKey}>
                                                            <h6 className="sa">
                                                              SA: {saKey}
                                                            </h6>
                                                            <div className="sa-flex-row">
                                                              <ol
                                                                type="1"
                                                                className="users"
                                                              >
                                                                {renderImageListItems(
                                                                  saValue,
                                                                  downloadProgress,
                                                                  handleDownloadClick,
                                                                )}
                                                              </ol>
                                                            </div>
                                                          </div>
                                                        );
                                                      },
                                                    )}
                                                  </div>
                                                );
                                              });
                                            },
                                          )}
                                        </div>
                                      )}
                                      {!patchKey && (
                                        <li className="woliWithoutPatch">
                                          {Object.entries(patchValue).map(
                                            ([workTypeKey, workTypeValue]) => {
                                              return Object.entries(
                                                workTypeValue,
                                              ).map(([woliKey, woliValue]) => {
                                                return (
                                                  <div>
                                                    <div key={woliKey}>
                                                      <h5 className="workLine">
                                                        Work type: {workTypeKey}
                                                      </h5>
                                                      <h5 className="workLine">
                                                        WOLI: {woliKey}
                                                      </h5>
                                                    </div>
                                                    {Object.entries(
                                                      woliValue,
                                                    ).map(
                                                      ([saKey, saValue]) => {
                                                        //{woliValue.map((item) => (
                                                        return (
                                                          <div key={saKey}>
                                                            <h6 className="sa">
                                                              SA: {saKey}
                                                            </h6>
                                                            <div className="sa-flex-row">
                                                              <ol
                                                                type="1"
                                                                className="users"
                                                              >
                                                                {renderImageListItems(
                                                                  saValue,
                                                                  downloadProgress,
                                                                  handleDownloadClick,
                                                                )}
                                                              </ol>
                                                            </div>
                                                          </div>
                                                        );
                                                      },
                                                    )}
                                                  </div>
                                                );
                                              });
                                            },
                                          )}
                                        </li>
                                      )}
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          )}
                          {!siteKey && (
                            <div className="patchNameBar">
                              {Object.entries(siteValue).map(
                                ([patchKey, patchValue]) => {
                                  return (
                                    <div key={patchKey}>
                                      {patchKey && (
                                        <div className="patchNameItem">
                                          <h4>
                                            <button
                                              className="patchNameButton"
                                              onClick={() =>
                                                togglePatchWithoutSiteExpansion(
                                                  patchKey,
                                                  setExpansionState,
                                                )
                                              }
                                            >
                                              {expansionState[patchKey]?.patch
                                                ? "-"
                                                : "+"}
                                            </button>
                                            Patch name: {patchKey}
                                          </h4>
                                        </div>
                                      )}
                                      {expansionState[patchKey]?.patch && (
                                        <li className="woli">
                                          {Object.entries(patchValue).map(
                                            ([workTypeKey, workTypeValue]) => {
                                              return Object.entries(
                                                workTypeValue,
                                              ).map(([woliKey, woliValue]) => {
                                                return (
                                                  <div>
                                                    <div key={woliKey}>
                                                      <h5 className="workLine">
                                                        Work type: {workTypeKey}
                                                      </h5>
                                                      <h5 className="workLine">
                                                        WOLI: {woliKey}
                                                      </h5>
                                                    </div>
                                                    {Object.entries(
                                                      woliValue,
                                                    ).map(
                                                      ([saKey, saValue]) => {
                                                        //{woliValue.map((item) => (
                                                        return (
                                                          <div key={saKey}>
                                                            <h6 className="sa">
                                                              SA: {saKey}
                                                            </h6>
                                                            <div className="sa-flex-row">
                                                              <ol
                                                                type="1"
                                                                className="users"
                                                              >
                                                                {renderImageListItems(
                                                                  saValue,
                                                                  downloadProgress,
                                                                  handleDownloadClick,
                                                                )}
                                                              </ol>
                                                            </div>
                                                          </div>
                                                        );
                                                      },
                                                    )}
                                                  </div>
                                                );
                                              });
                                            },
                                          )}
                                        </li>
                                      )}
                                      {!patchKey && (
                                        <div className="woliWithoutPatch">
                                          {Object.entries(patchValue).map(
                                            ([workTypeKey, workTypeValue]) => {
                                              return Object.entries(
                                                workTypeValue,
                                              ).map(([woliKey, woliValue]) => {
                                                return (
                                                  <div>
                                                    <div key={woliKey}>
                                                      <h5 className="workLine">
                                                        Work type: {workTypeKey}
                                                      </h5>
                                                      <h5 className="workLine">
                                                        WOLI: {woliKey}
                                                      </h5>
                                                    </div>
                                                    {Object.entries(
                                                      woliValue,
                                                    ).map(
                                                      ([saKey, saValue]) => {
                                                        //{woliValue.map((item) => (
                                                        return (
                                                          <div key={saKey}>
                                                            <h6 className="sa">
                                                              SA: {saKey}
                                                            </h6>
                                                            <div className="sa-flex-row">
                                                              <ol
                                                                type="1"
                                                                className="users"
                                                              >
                                                                {renderImageListItems(
                                                                  saValue,
                                                                  downloadProgress,
                                                                  handleDownloadClick,
                                                                )}
                                                              </ol>
                                                            </div>
                                                          </div>
                                                        );
                                                      },
                                                    )}
                                                  </div>
                                                );
                                              });
                                            },
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          )}
                        </li>
                      );
                    },
                  )}                      
                      {isOpenImage && openLightbox()}
                    </div>
                      {isGalleryControlsOpen && renderGalleryControlsSidebar()}
                    </div>
                  ) : (
                    <div className="galleryNoItemsShell">
                      {renderNoItemsState()}
                      {isGalleryControlsOpen && renderGalleryControlsSidebar()}
                    </div>
                  )}
                </div>
              </section>
            )}
          </>
        );
      } else if (recordType === "Reinstatement_Site_WOLI") {
        return (
          <>
            <ErrorDisplay
              errorMessage={errorMessage}
              unavailable={unavailable}
              onClose={onClose}
            />
            {errorMessage === "" && unavailable !== true && (
              <section>
                <div className="imageGrid">
                  <div className="headerContainer">
                    <div className="headerRow">
                      <div className="headerLeft">
                        <h4>Work Order: {workdIds[0]}</h4>
                      </div>
                      <div className="headerTop">
                        {archivedImages.some(
                          (img) => img.isFileArchived === "true",
                        ) && (
                          <button
                            className="btn-download btn-reArchive"
                            onClick={() =>
                              handleReArchive(
                                loaderdiv,
                                loaderOverlaydiv,
                                axios,
                                accessToken,
                                createDialogBox,
                                closeDialogBox,
                                downloadImages,
                                listThumbnails,
                                setDownloadImages,
                                setArchivedImages,
                                setListThumbnails,
                                setIsCheck,
                                setIsCheckAll,
                              )
                            }
                          >
                            Restore from archive
                          </button>
                        )}
                      </div>
                      <div className="headerActions">
                        <SelectAllCheckbox
                          isChecked={isCheckAll}
                          onChange={handleSelectAll}
                        />

                        {downloadButton}
                        {/* <GalleryControlsBar
                          isGalleryControlsOpen={isGalleryControlsOpen}
                          setIsGalleryControlsOpen={setIsGalleryControlsOpen}
                          closeGalleryControls={closeGalleryControls}
                          galleryControlsMode={galleryControlsMode}
                          openGalleryControls={openGalleryControls}
                          sortOption={sortOption}
                          handleSortChange={handleSortChange}
                          groupByServiceAppointment={groupByServiceAppointment}
                          toggleGroupByServiceAppointment={toggleGroupByServiceAppointment}
                          showGroupByServiceAppointment={isWoliSearch}
                          selectedFileTypeGroups={selectedFileTypeGroups}
                          toggleFileTypeGroup={toggleFileTypeGroup}
                          capturedDateFrom={capturedDateFrom}
                          handleCapturedDateFromChange={
                            handleCapturedDateFromChange
                          }
                          capturedDateTo={capturedDateTo}
                          handleCapturedDateToChange={handleCapturedDateToChange}
                          isSingleDateMode={isSingleDateMode}
                          handleSingleDateModeChange={handleSingleDateModeChange}
                          includeNoCapturedDate={includeNoCapturedDate}
                          handleIncludeNoCapturedDateChange={
                            handleIncludeNoCapturedDateChange
                          }
                          selectedEngineers={selectedEngineers}
                          toggleEngineerSelection={toggleEngineerSelection}
                          engineerSearch={engineerSearch}
                          setEngineerSearch={setEngineerSearch}
                          engineerOptions={engineerOptions}
                          clearGalleryFilters={clearGalleryFilters}
                          showSidebar={false}
                        />*/}
                      </div> 
                    </div>
                  </div>
                  {Object.keys(filteredUsersReinstatement).length > 0 ? (
                    <div className="sa-flex-row sitePatchControlsLayout">
                      <div className="sitePatchTree">
                        {Object.entries(filteredUsersReinstatement).map(
                          ([siteKey, siteValue]) => {
                      return (
                        <li key={siteKey} className="siteName">
                          <div className="siteNameBar">
                            <h4>
                              <button
                                className="siteNameButton"
                                onClick={() =>
                                  toggleSiteExpansion(
                                    siteKey,
                                    setExpansionState,
                                  )
                                }
                              >
                                {expansionState[siteKey]?.site ? "-" : "+"}
                              </button>
                              Site name: {siteKey}
                            </h4>
                          </div>
                          {expansionState[siteKey]?.site && (
                            <div className="workTypeBar">
                              {Object.entries(siteValue).map(
                                ([workTypeKey, workTypeValue]) => {
                                  return (
                                    <div key={workTypeKey}>
                                      {workTypeKey && (
                                        <div className="workTypeItem">
                                          <h4>
                                            <button
                                              className="workTypeButton"
                                              onClick={() =>
                                                toggleWorkTypeExpansion(
                                                  siteKey,
                                                  workTypeKey,
                                                  setExpansionState,
                                                )
                                              }
                                            >
                                              {expansionState[siteKey]?.[
                                                workTypeKey
                                              ]?.workType
                                                ? "-"
                                                : "+"}
                                            </button>
                                            Work type: {workTypeKey}
                                          </h4>
                                        </div>
                                      )}
                                      {expansionState[siteKey]?.[workTypeKey]
                                        ?.workType && (
                                        <div className="woli">
                                          {Object.entries(workTypeValue).map(
                                            ([woliKey, woliValue]) => {
                                              return (
                                                <div>
                                                  <div key={woliKey}>
                                                    <h5 className="workLine">
                                                      WOLI: {woliKey}
                                                    </h5>
                                                  </div>
                                                  {Object.entries(
                                                    woliValue,
                                                  ).map(([saKey, saValue]) => {
                                                    return (
                                                      <div key={saKey}>
                                                        <h6 className="sa">
                                                          SA: {saKey}
                                                        </h6>
                                                            <div className="sa-flex-row">
                                                              <ol
                                                                type="1"
                                                                className="users"
                                                              >
                                                            {renderImageListItems(
                                                              saValue,
                                                              downloadProgress,
                                                              handleDownloadClick,
                                                            )}
                                                          </ol>
                                                            </div>
                                                          </div>
                                                        );
                                                  })}
                                                </div>
                                              );
                                            },
                                          )}
                                        </div>
                                      )}
                                      {!workTypeKey && (
                                        <li className="woliWithoutWorkType">
                                          {Object.entries(workTypeValue).map(
                                            ([woliKey, woliValue]) => {
                                              return (
                                                <div>
                                                  <div key={woliKey}>
                                                    <h5 className="workLine">
                                                      WOLI: {woliKey}
                                                    </h5>
                                                  </div>
                                                  {Object.entries(
                                                    woliValue,
                                                  ).map(([saKey, saValue]) => {
                                                    return (
                                                      <div key={saKey}>
                                                        <h6 className="sa">
                                                          SA: {saKey}
                                                        </h6>
                                                        <div className="sa-flex-row">
                                                          <ol
                                                            type="1"
                                                            className="users"
                                                          >
                                                            {renderImageListItems(
                                                              saValue,
                                                              downloadProgress,
                                                              handleDownloadClick,
                                                            )}
                                                          </ol>
                                                        </div>
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              );
                                            },
                                          )}
                                        </li>
                                      )}
                                    </div>
                                  );
                                },
                              )}
                            </div>
                          )}
                        </li>
                      );
                    },
                  )}
                      {isOpenImage && openLightbox()}
                    </div>
                      {isGalleryControlsOpen && renderGalleryControlsSidebar()}
                    </div>
                  ) : (
                    <div className="galleryNoItemsShell">
                      {renderNoItemsState()}
                      {isGalleryControlsOpen && renderGalleryControlsSidebar()}
                    </div>
                  )}
                </div>
              </section>
            )}
          </>
        );
      } else {
        return (
          <>
            <ErrorDisplay
              errorMessage={errorMessage}
              unavailable={unavailable}
              onClose={onClose}
            />
            {errorMessage === "" && unavailable !== true && (
              <section>
                <div className="imageGrid">
                  <div className="headerContainer">
                    <div className="headerRow">
                      <div className="headerLeft">
                        <h4>Work Order: {workdIds[0]}</h4>
                      </div>
                      <div className="headerTop">
                        {archivedImages.some(
                          (img) => img.isFileArchived === "true",
                        ) && (
                          <button
                            className="btn-download btn-reArchive"
                            onClick={() =>
                              handleReArchive(
                                loaderdiv,
                                loaderOverlaydiv,
                                axios,
                                accessToken,
                                createDialogBox,
                                closeDialogBox,
                                downloadImages,
                                listThumbnails,
                                setDownloadImages,
                                setArchivedImages,
                                setListThumbnails,
                                setIsCheck,
                                setIsCheckAll,
                              )
                            }
                          >
                            Restore from archive
                          </button>
                        )}
                      </div>

                      <div className="headerActions">
                        <SelectAllCheckbox
                          isChecked={isCheckAll}
                          onChange={handleSelectAll}
                        />
                        <DownloadExcelButton currentItemsUsers={selectedItems}/>
                        <DownloadButton
                          isCheckAll={isCheckAll}
                          setIsCheckAll={setIsCheckAll}
                          isCheck={isCheck}
                          setIsCheck={setIsCheck}
                          ImgUri={ImgUri}
                          downloadImages={downloadImages}
                          downloadProgress={downloadProgress}
                          setDownloadProgress={setDownloadProgress}
                          wo={workdIds[0]}
                          totalCount={arrayWoli.length}
                          setDownloadImages={setDownloadImages}
                          setArchivedImages={setArchivedImages}
                          createDialogBox={createDialogBox}
                          closeDialogBox={closeDialogBox}
                          accessToken={accessToken}
                          setIsDownloadSidebarVisible={
                          setIsDownloadSidebarVisible
                          }
                        />
                        <GalleryControlsBar
                          isGalleryControlsOpen={isGalleryControlsOpen}
                          setIsGalleryControlsOpen={setIsGalleryControlsOpen}
                          closeGalleryControls={closeGalleryControls}
                          galleryControlsMode={galleryControlsMode}
                          openGalleryControls={openGalleryControls}
                          sortOption={sortOption}
                          handleSortChange={handleSortChange}
                          groupByServiceAppointment={groupByServiceAppointment}
                          toggleGroupByServiceAppointment={toggleGroupByServiceAppointment}
                          showGroupByServiceAppointment={isWoliSearch}
                          selectedFileTypeGroups={selectedFileTypeGroups}
                          toggleFileTypeGroup={toggleFileTypeGroup}
                          capturedDateFrom={capturedDateFrom}
                          handleCapturedDateFromChange={
                            handleCapturedDateFromChange
                          }
                          capturedDateTo={capturedDateTo}
                          handleCapturedDateToChange={handleCapturedDateToChange}
                          isSingleDateMode={isSingleDateMode}
                          handleSingleDateModeChange={handleSingleDateModeChange}
                          includeNoCapturedDate={includeNoCapturedDate}
                          handleIncludeNoCapturedDateChange={
                            handleIncludeNoCapturedDateChange
                          }
                          selectedEngineers={selectedEngineers}
                          toggleEngineerSelection={toggleEngineerSelection}
                          engineerSearch={engineerSearch}
                          setEngineerSearch={setEngineerSearch}
                          engineerOptions={engineerOptions}
                          clearGalleryFilters={clearGalleryFilters}
                          showSidebar={false}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="galleryResultsWithSidebar">
                    <div className="galleryResultsColumn">
                  {hasVisibleGalleryResults && hasPageResults ? (
                    <div className="woli">
                      {currentItemsUsers.map((page, pageIndex) =>
                        page.data.map((woli, woliIndex) => {
                          const visibleSaGroups = woli.data
                            .map((sa, saIndex) => {
                              const saNumber = (sa.serviceAppointmentNumber || "")
                                .toString()
                                .trim();
                              const visibleSaRecords =
                                selectedEngineers.length > 0
                                  ? sa.data.filter(recordMatchesSelectedEngineer)
                                  : sa.data;

                              if (
                                !Array.isArray(visibleSaRecords) ||
                                visibleSaRecords.length === 0
                              ) {
                                return null;
                              }

                              return {
                                key: `${woli.workOrderLineItemNumber}-${saNumber}-${saIndex}`,
                                saNumber,
                                visibleSaRecords,
                              };
                            })
                            .filter(Boolean);

                          if (visibleSaGroups.length === 0) {
                            return null;
                          }

                          // When loading a WOLI search with grouping disabled,
                          // don't render SA banners — flatten records and show
                          // them in strict chronological order under the WOLI.
                          if (!groupByServiceAppointment && isWoliSearch) {
                            const flattened = visibleSaGroups.flatMap(
                              (g) => g.visibleSaRecords,
                            );

                            if (!Array.isArray(flattened) || flattened.length === 0) {
                              return null;
                            }

                            return (
                              <div
                                key={`${woli.workOrderLineItemNumber}-${pageIndex}-${woliIndex}`}
                              >
                                <h5 className="workLine">
                                  WOLI&nbsp;:&nbsp;&nbsp;&nbsp;
                                  {woli.workOrderLineItemNumber}
                                </h5>
                                <div className="sa-flex-row">
                                  <ol type="1" className="users">
                                    {renderImageListItems(
                                      flattened,
                                      downloadProgress,
                                      handleDownloadClick,
                                    )}
                                  </ol>
                                </div>
                              </div>
                            );
                          }

                          return (
                            <div
                              key={`${woli.workOrderLineItemNumber}-${pageIndex}-${woliIndex}`}
                            >
                              <h5 className="workLine">
                                WOLI&nbsp;:&nbsp;&nbsp;&nbsp;
                                {woli.workOrderLineItemNumber}
                              </h5>
                              {visibleSaGroups.map((saGroup) => (
                                <div key={saGroup.key}>
                                  <h6 className="sa">
                                    SA No.&nbsp;:&nbsp;&nbsp;&nbsp;
                                    {saGroup.saNumber || sa || saNo || (saGroup.visibleSaRecords && saGroup.visibleSaRecords[0] && saGroup.visibleSaRecords[0].serviceAppointmentNumber)}
                                  </h6>
                                  <div className="sa-flex-row">
                                    <ol type="1" className="users">
                                      {renderImageListItems(
                                        saGroup.visibleSaRecords,
                                        downloadProgress,
                                        handleDownloadClick,
                                      )}
                                    </ol>
                                  </div>
                                </div>
                              ))}
                            </div>
                          );
                        }),
                      )}
                      {isOpenImage && openLightbox()}
                      <PaginationUsers
                        extractedData={extractedData}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        isCheckAll={setIsCheckAll}
                      />
                    </div>
                  ) : (
                    <div className="galleryNoItemsShell">
                      {renderNoItemsState()}
                    </div>
                  )}
                    </div>
                    {isDownloadSidebarVisible && renderDownloadSidebar()}
                    {isGalleryControlsOpen && renderGalleryControlsSidebar()}
                  </div>
                </div>
              </section>
            )}
          </>
        );
      }
    }
  }
};
export default Gallery;


